// // // components/support/SupportSystem.jsx
// // import React, { useState } from 'react';
// // // import RaiseTicket from './RaiseTicket';
// // // import HelpSupportCenter from './HelpSupportCenter';
// // // import LiveChatSupport from './LiveChatSupport';
// // // import FAQKnowledgeBase from './FAQKnowledgeBase';
// // import FoodRaiseTicket from './FoodRaiseTicket';

// // const FoodSupportSystem = () => {
// //   const [activeTab, setActiveTab] = useState('help-center');
  
// //   // Placeholder components for features not yet implemented
// //   const ComingSoon = ({ featureName }) => (
// //     <div className="coming-soon">
// //       <h3>{featureName} - Coming Soon</h3>
// //       <p>This feature is currently under development and will be available soon.</p>
// //     </div>
// //   );

// //   const tabs = [
// //     // { id: 'help-center', label: 'Help Center', component: <HelpSupportCenter /> },
// //     { id: 'raise-ticket', label: 'Raise a Ticket', component: <FoodRaiseTicket /> },
// //     // { id: 'live-chat', label: 'Live Chat', component: <ComingSoon featureName="Live Chat & Bot Support" /> },
// //     // { id: 'faq', label: 'FAQs', component: <ComingSoon featureName="FAQs & Knowledge Base" /> },
// //   ];

// //   return (
// //     <div className="support-system">
// //       <div className="support-header">
// //         <h1>Support System</h1>
// //         <p>Get help, report issues, or find answers to common questions</p>
// //       </div>
      
// //       <div className="support-tabs">
// //         {tabs.map((tab) => (
// //           <button
// //             key={tab.id}
// //             className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
// //             onClick={() => setActiveTab(tab.id)}
// //           >
// //             {tab.label}
// //           </button>
// //         ))}
// //       </div>
      
// //       <div className="support-content">
// //         {tabs.find(tab => tab.id === activeTab)?.component}
// //       </div>
// //     </div>
// //   );
// // };

// // export default FoodSupportSystem;



// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { 
//   FaCheckCircle, 
//   FaExclamationTriangle, 
//   FaClock, 
//   FaDatabase, 
//   FaShieldAlt, 
//   FaGavel, 
//   FaBook, 
//   FaTimes, 
//   FaUtensils, 
//   FaShoppingCart, 
//   FaTruck, 
//   FaGlassCheers, 
//   FaStar, 
//   FaUsers, 
//   FaChartLine, 
//   FaCertificate, 
//   FaChartBar, 
//   FaChartPie, 
//   FaBalanceScale, 
//   FaClipboardCheck, 
//   FaExclamationCircle, 
//   FaCalendarCheck, 
//   FaRegCalendarAlt,
//   FaArrowRight
// } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import { useLoader } from "../../../context/LoaderProvider.jsx";
// import Foodandbeveragesadvertise from './Foodandbeveragesadvertise';

// // Document Viewer Modal Component
// const DocumentViewerModal = ({ isOpen, onClose, title, content }) => {
//   if (!isOpen) return null;

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.8)',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       zIndex: 9999,
//       padding: '20px'
//     }}>
//       <div style={{
//         backgroundColor: 'white',
//         borderRadius: '12px',
//         padding: window.innerWidth < 768 ? '15px' : '20px',
//         maxWidth: window.innerWidth < 768 ? '95%' : '80%',
//         width: '100%',
//         maxHeight: window.innerWidth < 768 ? '80vh' : '85vh',
//         display: 'flex',
//         flexDirection: 'column',
//         boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
//         position: 'relative'
//       }}>
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: '15px',
//           paddingBottom: '10px',
//           borderBottom: '2px solid #A055B0',
//           flexWrap: 'wrap',
//           gap: '10px'
//         }}>
//           <h3 style={{
//             margin: 0,
//             color: '#A055B0',
//             fontSize: window.innerWidth < 768 ? '18px' : '22px',
//             fontWeight: 'bold',
//             flex: 1
//           }}>
//             {title}
//           </h3>
          
//           <button 
//             onClick={onClose}
//             aria-label="Close document viewer"
//             style={{
//               backgroundColor: '#f44336',
//               color: 'white',
//               border: 'none',
//               padding: window.innerWidth < 768 ? '8px 12px' : '10px 20px',
//               borderRadius: '5px',
//               cursor: 'pointer',
//               fontSize: window.innerWidth < 768 ? '12px' : '14px',
//               fontWeight: 'bold',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '8px',
//               transition: 'all 0.3s ease'
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.backgroundColor = '#d32f2f';
//               e.currentTarget.style.transform = 'translateY(-2px)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.backgroundColor = '#f44336';
//               e.currentTarget.style.transform = 'translateY(0)';
//             }}
//           >
//             <FaTimes aria-hidden="true" /> Close
//           </button>
//         </div>

//         <div style={{
//           flex: 1,
//           overflowY: 'auto',
//           padding: '15px',
//           backgroundColor: '#f9f9f9',
//           borderRadius: '8px',
//           border: '1px solid #ddd',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           color: '#666'
//         }}>
//           <div style={{ textAlign: 'center' }}>
//             <FaBook aria-hidden="true" style={{ fontSize: '48px', color: '#A055B0', marginBottom: '15px' }} />
//             <h4>Document Content Removed</h4>
//             <p>This document content has been removed as per requirements.</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Success Modal Component
// const SuccessModal = ({ isOpen, onClose, message, title = "Success!" }) => {
//   if (!isOpen) return null;

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.5)',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       zIndex: 9999,
//       padding: '20px'
//     }}>
//       <div style={{
//         backgroundColor: 'white',
//         borderRadius: '12px',
//         padding: window.innerWidth < 768 ? '20px' : '30px',
//         maxWidth: window.innerWidth < 768 ? '90%' : '500px',
//         width: '100%',
//         boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
//         position: 'relative'
//       }}>
//         <button 
//           onClick={onClose}
//           aria-label="Close success modal"
//           style={{
//             position: 'absolute',
//             top: '15px',
//             right: '15px',
//             background: 'none',
//             border: 'none',
//             fontSize: '20px',
//             color: '#666',
//             cursor: 'pointer',
//             width: '30px',
//             height: '30px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             borderRadius: '50%',
//             transition: 'all 0.3s ease'
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.backgroundColor = '#f5f5f5';
//             e.currentTarget.style.color = '#333';
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.backgroundColor = 'transparent';
//             e.currentTarget.style.color = '#666';
//           }}
//         >
//           <FaTimes aria-hidden="true" />
//         </button>

//         <div style={{
//           display: 'flex',
//           justifyContent: 'center',
//           marginBottom: '20px'
//         }}>
//           <div style={{
//             width: '80px',
//             height: '80px',
//             borderRadius: '50%',
//             backgroundColor: '#4CAF50',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             animation: 'scaleIn 0.5s ease-out'
//           }}>
//             <FaCheckCircle aria-hidden="true" style={{ color: 'white', fontSize: '40px' }} />
//           </div>
//         </div>

//         <h3 style={{
//           textAlign: 'center',
//           color: '#4CAF50',
//           margin: '0 0 15px 0',
//           fontSize: window.innerWidth < 768 ? '22px' : '24px',
//           fontWeight: 'bold'
//         }}>
//           {title}
//         </h3>

//         <div style={{
//           textAlign: 'center',
//           color: '#555',
//           fontSize: window.innerWidth < 768 ? '16px' : '18px',
//           lineHeight: '1.5',
//           marginBottom: '25px',
//           padding: '0 10px'
//         }}>
//           {message}
//         </div>

//         <div style={{ textAlign: 'center' }}>
//           <button 
//             onClick={onClose}
//             aria-label="Close success message"
//             style={{
//               backgroundColor: '#4CAF50',
//               color: 'white',
//               border: 'none',
//               padding: window.innerWidth < 768 ? '12px 30px' : '14px 40px',
//               borderRadius: '50px',
//               cursor: 'pointer',
//               fontSize: window.innerWidth < 768 ? '16px' : '18px',
//               fontWeight: 'bold',
//               minWidth: '150px',
//               transition: 'all 0.3s ease',
//               boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)'
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.backgroundColor = '#388E3C';
//               e.currentTarget.style.transform = 'translateY(-2px)';
//               e.currentTarget.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.backgroundColor = '#4CAF50';
//               e.currentTarget.style.transform = 'translateY(0)';
//               e.currentTarget.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.3)';
//             }}
//           >
//             OK, Got it!
//           </button>
//         </div>
//       </div>

//       <style>{`
//         @keyframes scaleIn {
//           from {
//             transform: scale(0);
//             opacity: 0;
//           }
//           to {
//             transform: scale(1);
//             opacity: 1;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// // Custom Terms Component
// const CustomTerms = ({ onNext, onBack, autoAgree = false }) => {
//   const [agreed, setAgreed] = useState(false);

//   // Auto-agree when component mounts if autoAgree prop is true
//   useEffect(() => {
//     if (autoAgree) {
//       setAgreed(true);
//     }
//   }, [autoAgree]);

//   const policySections = [
//     {
//       id: "reservation",
//       title: "Reservation Policy",
//       icon: <FaCalendarCheck aria-hidden="true" />,
//       color: "#4CAF50",
//       points: [
//         "Customers are encouraged to make reservations in advance.",
//         "Reservations are held for 15 minutes beyond the scheduled time.",
//         "Large group reservations (8+ people) require 24-hour notice for cancellations.",
//         "Special occasion reservations may require a deposit."
//       ]
//     },
//     {
//       id: "cancellation",
//       title: "Cancellation Policy",
//       icon: <FaTimes aria-hidden="true" />,
//       color: "#FF9800",
//       points: [
//         "Please cancel or modify your reservation at least 2 hours before your scheduled time.",
//         "Late cancellations may incur a fee of 50% of the estimated bill.",
//         "No-shows will be charged 100% of the reservation deposit.",
//         "Special event cancellations require 48-hour notice."
//       ]
//     },
//     {
//       id: "payment",
//       title: "Payment Terms",
//       icon: <FaShoppingCart aria-hidden="true" />,
//       color: "#2196F3",
//       points: [
//         "We accept cash, major credit/debit cards, and online payments.",
//         "All prices are inclusive of applicable taxes unless mentioned otherwise.",
//         "Service charge of 10% may apply for parties of 6 or more.",
//         "Split bills are subject to individual card minimums."
//       ]
//     },
//     // {
//     //   id: "food-beverage",
//     //   title: "Food & Beverage Policies",
//     //   icon: <FaUtensils aria-hidden="true" />,
//     //   color: "#9C27B0",
//     //   points: [
//     //     "Outside food and beverages are not permitted.",
//     //     "Special dietary requirements must be communicated in advance.",
//     //     "Food allergies must be declared at the time of ordering.",
//     //     "Unfinished food may be packaged for takeaway upon request."
//     //   ]
//     // }
//   ];

//   const handleNext = () => {
//     if (!agreed) {
//       alert("Please read and agree to the Terms & Conditions before proceeding.");
//       return;
//     }

//     // Mark terms as compliant
//     const data = {
//       agreed: true,
//       agreedDate: new Date().toISOString(),
//       vendorId: localStorage.getItem("vendorId") || "",
//       vendorName: localStorage.getItem("vendorName") || "",
//       termsVersion: "v1.5",
//       submissionId: `TNC-${Date.now()}`,
//       vendorEmail: localStorage.getItem("vendorEmail") || "vendor@example.com"
//     };

//     console.log("Terms & Conditions agreed:", data);

//     // Call onNext callback if provided
//     if (onNext) {
//       onNext(data);
//     }
//   };

//   return (
//     <div 
//       role="document"
//       aria-label="Terms and Conditions Agreement"
//       title="Terms and Conditions Agreement Document"
//       style={{
//         maxWidth: '900px',
//         margin: '0 auto',
//         padding: window.innerWidth < 768 ? '10px' : '20px'
//       }}
//     >
//       {/* Header */}
//       <header style={{
//         textAlign: 'center',
//         marginBottom: '50px'
//       }}>
//         <h1 style={{
//           margin: '0 0 15px 0',
//           fontSize: window.innerWidth < 768 ? '26px' : '34px',
//           fontWeight: 'bold',
//           color: '#333',
//           backgroundImage: 'linear-gradient(135deg, #A055B0 0%, #8a4b9b 100%)',
//           backgroundClip: 'text',
//           WebkitBackgroundClip: 'text',
//           WebkitTextFillColor: 'transparent',
//           textSizeAdjust: '100%',
//           WebkitTextSizeAdjust: '100%'
//         }}>
//           Terms & Conditions Agreement
//         </h1>
        
//         <div style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: '15px',
//           flexWrap: 'wrap',
//           fontSize: '14px',
//           color: '#666',
//           textAlign: 'match-parent',
//           textAlign: '-webkit-match-parent'
//         }}>
//           {/* <span style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: '5px'
//           }}>
//             <FaGavel aria-hidden="true" style={{ color: '#A055B0' }} />
//             Version 1.5
//           </span>
//           <span aria-hidden="true" style={{ color: '#999' }}>•</span>
//           <span>
//             Last Updated: March 15, 2024
//           </span> */}
//         </div>
//       </header>

//       {/* Policy Sections */}
//       <div style={{
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '60px',
//         marginBottom: '50px'
//       }}>
//         {policySections.map((section) => (
//           <section 
//             key={section.id}
//             id={section.id}
//             aria-labelledby={`${section.id}-title`}
//             style={{
//               position: 'relative',
//               paddingLeft: window.innerWidth < 768 ? '20px' : '45px'
//             }}
//           >
//             {/* Vertical Line */}
//             <div 
//               role="presentation"
//               aria-hidden="true"
//               title=""
//               style={{
//                 position: 'absolute',
//                 left: window.innerWidth < 768 ? '8px' : '22px',
//                 top: '40px',
//                 bottom: '-40px',
//                 width: '2px',
//                 backgroundColor: section.color + '30',
//                 zIndex: 0
//               }}
//             />
            
//             {/* Icon Circle */}
//             <div 
//               role="presentation"
//               aria-hidden="true"
//               title=""
//               style={{
//                 position: 'absolute',
//                 left: window.innerWidth < 768 ? '0' : '12px',
//                 top: '0',
//                 width: '28px',
//                 height: '28px',
//                 borderRadius: '50%',
//                 backgroundColor: section.color,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 color: 'white',
//                 zIndex: 1,
//                 fontSize: '14px'
//               }}
//             >
//               {section.icon}
//             </div>
            
//             {/* Content */}
//             <div style={{ position: 'relative', zIndex: 1 }}>
//               <h2 
//                 id={`${section.id}-title`}
//                 style={{
//                   margin: '0 0 25px 0',
//                   fontSize: window.innerWidth < 768 ? '20px' : '24px',
//                   color: section.color,
//                   fontWeight: 'bold',
//                   paddingBottom: '12px',
//                   borderBottom: `2px solid ${section.color}20`
//                 }}
//               >
//                 {section.title}
//               </h2>
              
//               <ul 
//                 aria-label={`Points for ${section.title}`}
//                 style={{
//                   listStyleType: 'none',
//                   padding: 0,
//                   margin: 0
//                 }}
//               >
//                 {section.points.map((point, index) => (
//                   <li 
//                     key={index}
//                     style={{
//                       marginBottom: '22px',
//                       position: 'relative',
//                       paddingLeft: '35px',
//                       fontSize: window.innerWidth < 768 ? '15px' : '16px',
//                       lineHeight: '1.7',
//                       color: '#444'
//                     }}
//                   >
//                     <div 
//                       role="presentation"
//                       aria-hidden="true"
//                       title=""
//                       style={{
//                         position: 'absolute',
//                         left: '0',
//                         top: '8px',
//                         width: '20px',
//                         height: '20px',
//                         borderRadius: '50%',
//                         backgroundColor: section.color + '20',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         fontSize: '10px',
//                         color: section.color,
//                         fontWeight: 'bold'
//                       }}
//                     >
//                       {index + 1}
//                     </div>
//                     {point}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </section>
//         ))}
//       </div>

//       {/* Important Notice */}
//       <section 
//         aria-label="Important Notice"
//         style={{
//           marginBottom: '10px',
//           padding: '10px',
//           borderRadius: '8px',
//           background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
//           position: 'relative'
//         }}
//       >
//         <div 
//           role="presentation"
//           aria-hidden="true"
//           title=""
//           style={{
//             position: 'absolute',
//             top: '15px',
//             right: '15px',
//             fontSize: '30px',
//             color: '#A055B0',
//             opacity: 0.1
//           }}
//         >
//           <FaExclamationTriangle aria-hidden="true" />
//         </div>
        
//         <div style={{
//           display: 'flex',
//           alignItems: 'flex-start',
//           gap: '12px',
//           marginBottom: '12px'
//         }}>
//           <FaExclamationTriangle aria-hidden="true" style={{
//             color: '#A055B0',
//             fontSize: '18px',
//             flexShrink: 0,
//             marginTop: '3px'
//           }} />
//           <h3 style={{
//             margin: 0,
//             color: '#333',
//             fontSize: '17px',
//             fontWeight: 'bold'
//           }}>
//             Important Notice
//           </h3>
//         </div>
        
//         <p style={{
//           margin: 0,
//           fontSize: '15px',
//           color: '#555',
//           lineHeight: '1.7',
//           paddingLeft: '30px'
//         }}>
//           By agreeing to these terms, you confirm you've read and understood our policies. Terms may change with notice. We reserve the right to refuse service at any time.
//         </p>
//       </section>

//       {/* Agreement Section */}
//       <section 
//         aria-label="Agreement Section"
//         style={{
//           marginBottom: '10px',
//           padding: '25px 0',
//           borderTop: '2px solid #f0f0f0',
//           borderBottom: '2px solid #f0f0f0'
//         }}
//       >
//         <div style={{
//           display: 'flex',
//           alignItems: 'flex-start',
//           gap: '20px',
//           flexDirection: window.innerWidth < 768 ? 'column' : 'row'
//         }}>
//           <div style={{
//             flexShrink: 0,
//             position: 'relative'
//           }}>
//             <input 
//               type="checkbox" 
//               id="termsAgreement"
//               checked={agreed}
//               onChange={(e) => setAgreed(e.target.checked)}
//               aria-labelledby="termsAgreementLabel"
//               style={{
//                 position: 'absolute',
//                 opacity: 0,
//                 width: 0,
//                 height: 0
//               }}
//             />
//             <label 
//               htmlFor="termsAgreement"
//               title="Agree to Terms and Conditions checkbox"
//               style={{
//                 display: 'block',
//                 width: '36px',
//                 height: '36px',
//                 borderRadius: '6px',
//                 border: `2px solid ${agreed ? '#4CAF50' : '#ddd'}`,
//                 background: agreed ? '#4CAF50' : 'white',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontSize: '18px',
//                 color: 'white',
//                 fontWeight: 'bold'
//               }}
//             >
//               {agreed && <FaCheckCircle aria-hidden="true" />}
//             </label>
//           </div>
          
//           <div style={{ flex: 1 }}>
//             <label 
//               id="termsAgreementLabel"
//               htmlFor="termsAgreement"
//               style={{
//                 display: 'block',
//                 fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                 fontWeight: 'bold',
//                 color: agreed ? '#2e7d32' : '#333',
//                 cursor: 'pointer',
//                 lineHeight: '1.5',
//                 marginBottom: '8px'
//             }}>
//               {agreed ? '✓ I agree to the Terms & Conditions' : 'I agree to the Terms & Conditions'}
//             </label>
//             <p style={{
//               margin: 0,
//               fontSize: '15px',
//               color: agreed ? '#4CAF50' : '#666',
//               lineHeight: '1.6'
//             }}>
//               {agreed 
//                 ? 'You have read and agreed to all policies stated above.'
//                 : 'You must read and agree to the Terms and Conditions before proceeding to Vendor Guidelines.'
//               }
//             </p>
//             {autoAgree && agreed && (
//               <div style={{
//                 marginTop: '10px',
//                 padding: '8px 12px',
//                 backgroundColor: '#e8f5e9',
//                 borderRadius: '6px',
//                 fontSize: '14px',
//                 color: '#2e7d32',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px'
//               }}>
//                 <FaCheckCircle aria-hidden="true" />
//                 Auto-agreed for convenience
//               </div>
//             )}
//           </div>
//         </div>
//       </section>

//       {/* Navigation Buttons */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginTop: '40px',
//         paddingTop: '20px',
//         borderTop: '1px solid #e0e0e0',
//         flexDirection: window.innerWidth < 768 ? 'column' : 'row',
//         gap: window.innerWidth < 768 ? '15px' : '0'
//       }}>
//         <button 
//           onClick={onBack}
//           aria-label="Go back to Privacy Policy"
//           style={{
//             padding: window.innerWidth < 768 ? '14px 30px' : '16px 40px',
//             borderRadius: '8px',
//             border: '2px solid #A055B0',
//             background: 'white',
//             color: '#A055B0',
//             cursor: 'pointer',
//             fontSize: window.innerWidth < 768 ? '14px' : '16px',
//             fontWeight: '600',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '10px',
//             transition: 'all 0.3s ease',
//             minWidth: '180px',
//             order: window.innerWidth < 768 ? 2 : 1
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.backgroundColor = '#f5f0f7';
//             e.currentTarget.style.transform = 'translateY(-2px)';
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.backgroundColor = 'white';
//             e.currentTarget.style.transform = 'translateY(0)';
//           }}
//         >
//           ← Back to Privacy Policy
//         </button>

//         <button 
//           onClick={handleNext}
//           disabled={!agreed}
//           aria-label={agreed ? "Proceed to Vendor Guidelines" : "Please agree to terms first"}
//           title={agreed ? "Navigate to Vendor Guidelines" : "You must agree to the terms first"}
//           style={{
//             padding: window.innerWidth < 768 ? '14px 30px' : '16px 40px',
//             borderRadius: '8px',
//             border: 'none',
//             background: agreed ? 'linear-gradient(135deg, #A055B0 0%, #8a4b9b 100%)' : '#e0e0e0',
//             color: agreed ? 'white' : '#999',
//             cursor: agreed ? 'pointer' : 'not-allowed',
//             fontSize: window.innerWidth < 768 ? '14px' : '16px',
//             fontWeight: '600',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '10px',
//             transition: agreed ? 'all 0.3s ease' : 'none',
//             boxShadow: agreed ? '0 4px 12px rgba(160, 85, 176, 0.2)' : 'none',
//             minWidth: '220px',
//             order: 1
//           }}
//           onMouseEnter={(e) => {
//             if (agreed) {
//               e.currentTarget.style.transform = 'translateY(-2px)';
//               e.currentTarget.style.boxShadow = '0 6px 16px rgba(160, 85, 176, 0.3)';
//             }
//           }}
//           onMouseLeave={(e) => {
//             if (agreed) {
//               e.currentTarget.style.transform = 'translateY(0)';
//               e.currentTarget.style.boxShadow = '0 4px 12px rgba(160, 85, 176, 0.2)';
//             }
//           }}
//         >
//           {agreed ? (
//             <>
//               Next: Vendor Guidelines
//               <FaArrowRight aria-hidden="true" />
//             </>
//           ) : (
//             'Next: Vendor Guidelines'
//           )}
//         </button>
//       </div>
//     </div>
//   );
// };

// const FoodLeagelandcompliance = () => {
//     const [activeTab, setActiveTab] = useState("Privacy Policy");
//     const { showLoader, hideLoader } = useLoader();
//     const [showDocumentViewer, setShowDocumentViewer] = useState(false);
//     const [currentDocument, setCurrentDocument] = useState({ title: '', content: '', type: '' });
//     const [termsTabJustOpened, setTermsTabJustOpened] = useState(false);

//     const [complianceData, setComplianceData] = useState({
//         privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15" },
//         termsConditions: { status: "pending", lastUpdated: "2024-02-28" },
//         vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20" },
//         gdpr: { status: "compliant", lastUpdated: "2024-03-10" },
//         dataRetention: { status: "compliant", lastUpdated: "2024-03-05" }
//     });

//     const [vendorId, setVendorId] = useState(null);

//     // Clean up: Remove unused document contents or actually use them
//     const documentContents = {
//         privacyPolicy: {
//             title: "Privacy Policy - FoodLeague Platform",
//             content: (
//                 <div style={{ lineHeight: '1.6', textAlign: 'center', padding: '50px 20px' }}>
//                     <FaBook aria-hidden="true" style={{ fontSize: '64px', color: '#A055B0', marginBottom: '20px' }} />
//                     <h3>Privacy Policy Content</h3>
//                     <p>This document content has been removed as per requirements.</p>
//                 </div>
//             )
//         },
//         termsConditions: {
//             title: "Terms & Conditions - FoodLeague Platform",
//             content: (
//                 <div style={{ lineHeight: '1.6', textAlign: 'center', padding: '50px 20px' }}>
//                     <FaBook aria-hidden="true" style={{ fontSize: '64px', color: '#A055B0', marginBottom: '20px' }} />
//                     <h3>Terms & Conditions Content</h3>
//                     <p>This document content has been removed as per requirements.</p>
//                 </div>
//             )
//         },
//         vendorGuidelines: {
//             title: "Vendor Guidelines - FoodLeague Platform",
//             content: (
//                 <div style={{ lineHeight: '1.6', textAlign: 'center', padding: '50px 20px' }}>
//                     <FaBook aria-hidden="true" style={{ fontSize: '64px', color: '#A055B0', marginBottom: '20px' }} />
//                     <h3>Vendor Guidelines Content</h3>
//                     <p>This document content has been removed as per requirements.</p>
//                 </div>
//             )
//         }
//     };

//     // Clean up: Remove unused functions or actually use them
//     const handleViewDocument = useCallback((type) => {
//         setCurrentDocument({
//             title: documentContents[type].title,
//             content: documentContents[type].content,
//             type: type
//         });
//         setShowDocumentViewer(true);
//     }, [documentContents]);

//     const handleCloseDocumentViewer = useCallback(() => {
//         setShowDocumentViewer(false);
//     }, []);

//     // Responsive container height function
//     const getContainerHeight = useCallback(() => {
//       const width = window.innerWidth;
//       const height = window.innerHeight;

//       if (height <= 600) {
//         return width < 768 ? '250px' : width < 992 ? '300px' : '350px';
//       }

//       if (width < 576) return '50vh';
//       if (width < 768) return '55vh';
//       if (width < 992) return '60vh';
//       if (width < 1200) return '65vh';
//       return '70vh';
//     }, []);

//     const containerHeight = getContainerHeight();

//     // Function to get tab display text - Always show full text
//     const getTabDisplayText = useCallback((label) => {
//       // Always show full text
//       return label;
//     }, []);

//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         if (storedVendorId) {
//             setVendorId(storedVendorId);
//         }
//     }, []);

//     // Fetch compliance data with CORS fix
//     const fetchComplianceData = useCallback(async () => {
//         try {
//             showLoader();
//             const vendorId = localStorage.getItem("vendorId");
//             const token = localStorage.getItem("authToken");

//             if (!token || !vendorId) {
//                 console.warn("Missing token or vendorId");
//                 return;
//             }

//             // For development, use mock data instead of actual API call
//             // Remove or comment this in production when CORS is fixed
//             const mockData = {
//                 privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15", version: "v2.1" },
//                 termsConditions: { status: "pending", lastUpdated: "2024-02-28", version: "v1.5" },
//                 vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20", version: "v3.0" },
//                 gdpr: { status: "compliant", lastUpdated: "2024-03-10", version: "v1.2" },
//                 dataRetention: { status: "compliant", lastUpdated: "2024-03-05", version: "v1.0" }
//             };
            
//             setComplianceData(mockData);
            
//         } catch (error) {
//             console.error("Failed to fetch compliance data:", error);
//             // Use mock data as fallback
//             setComplianceData({
//                 privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15", version: "v2.1" },
//                 termsConditions: { status: "pending", lastUpdated: "2024-02-28", version: "v1.5" },
//                 vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20", version: "v3.0" },
//                 gdpr: { status: "compliant", lastUpdated: "2024-03-10", version: "v1.2" },
//                 dataRetention: { status: "compliant", lastUpdated: "2024-03-05", version: "v1.0" }
//             });
//         } finally {
//             hideLoader();
//         }
//     }, [showLoader, hideLoader]);

//     useEffect(() => {
//         fetchComplianceData();
//     }, [fetchComplianceData]);

//     const getStatusIcon = useCallback((status) => {
//         switch(status) {
//             case 'compliant': return <FaCheckCircle aria-hidden="true" style={{ color: '#4CAF50', marginRight: '5px' }} />;
//             case 'pending': return <FaClock aria-hidden="true" style={{ color: '#FFC107', marginRight: '5px' }} />;
//             case 'non-compliant': return <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '5px' }} />;
//             default: return null;
//         }
//     }, []);

//     const getStatusColor = useCallback((status) => {
//         switch(status) {
//             case 'compliant': return '#4CAF50';
//             case 'pending': return '#FFC107';
//             case 'non-compliant': return '#f44336';
//             default: return '#757575';
//         }
//     }, []);

//     // Tab content definitions
//     const tabContent = {
//         "Privacy Policy": (
//             <div style={{ padding: window.innerWidth < 768 ? '0px' : '10px 10px' }}>
//                 <div style={cardStyle}>
//                     <div style={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         alignItems: 'center',
//                         flexDirection: window.innerWidth < 576 ? 'column' : 'row',
//                         gap: window.innerWidth < 576 ? '10px' : '0'
//                     }}>
//                         {/* Content removed as per requirements */}
//                     </div>
                    
//                     <div style={{ marginTop: '10px' }}>
//                         <div style={{ 
//                             borderRadius: '12px',
//                             marginBottom: '15px',
//                         }}>
//                             <h5 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '18px' : '22px',
//                                 color: '#2e7d32',
//                                 marginBottom: '15px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 <FaShieldAlt aria-hidden="true" style={{ marginRight: '12px' }} />
//                                 Food & Beverages Vendor Data Protection
//                             </h5>
                            
//                             <div style={{ 
//                                 borderRadius: '10px',
//                                 marginBottom: '15px',
//                             }}>
//                                 <h6 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                     color: '#2e7d32',
//                                     marginBottom: '15px'
//                                 }}>
//                                     🍽️ Food Safety & Ingredient Data Collection
//                                 </h6>
//                                 <ul style={{ paddingLeft: '20px', fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6' }}>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Temperature Monitoring:</strong> We collect and secure temperature logs for refrigeration and cooking equipment to ensure food safety compliance. All temperature data is encrypted and stored for regulatory audits.
//                                     </li>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Ingredient Sourcing:</strong> Detailed information about ingredient suppliers, batch numbers, and expiration dates are securely stored with end-to-end encryption to maintain supply chain transparency.
//                                     </li>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Preparation Protocols:</strong> Food preparation methods, cooking times, and handling procedures are documented with strict access controls to protect proprietary recipes and ensure consistency.
//                                     </li>
//                                 </ul>
//                             </div>

//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '10px',
//                                 marginBottom: '15px',
//                             }}>
//                                 <h6 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                     color: '#2e7d32',
//                                     marginBottom: '15px'
//                                 }}>
//                                     🚫 Allergy & Dietary Restriction Management
//                                 </h6>
//                                 <ul style={{ paddingLeft: '20px', fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6' }}>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Customer Allergy Profiles:</strong> We implement zero-knowledge encryption for sensitive allergy information. Data is anonymized and only accessible to authorized kitchen staff during order preparation.
//                                     </li>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Dietary Preferences:</strong> Vegan, vegetarian, gluten-free, and other dietary preferences are stored with explicit customer consent and can be deleted upon request at any time.
//                                     </li>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Cross-Contamination Prevention:</strong> Our system tracks and logs allergen-free preparation zones with real-time monitoring to ensure customer safety.
//                                     </li>
//                                 </ul>
//                             </div>

//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '10px',
//                                 marginBottom: '15px',
//                             }}>
//                                 <h6 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                     color: '#2e7d32',
//                                     marginBottom: '15px'
//                                 }}>
//                                     📊 Customer Experience & Personalization
//                                 </h6>
//                                 <ul style={{ paddingLeft: '20px', fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6' }}>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Menu Preferences:</strong> Customer food preferences, favorite dishes, and order history are analyzed with machine learning algorithms to provide personalized recommendations while maintaining data anonymity.
//                                     </li>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Feedback Analysis:</strong> Customer reviews and feedback are processed to improve service quality. All feedback is anonymized after 30 days unless explicit consent is given for longer retention.
//                                     </li>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Loyalty Programs:</strong> Points, rewards, and special offers data is protected with bank-level security protocols and regular security audits.
//                                     </li>
//                                 </ul>
//                             </div>

//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '10px',
//                             }}>
//                                 <h6 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                     color: '#2e7d32',
//                                     marginBottom: '15px'
//                                 }}>
//                                     💳 Payment & Transaction Security
//                                 </h6>
//                                 <ul style={{ paddingLeft: '20px', fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6' }}>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>PCI-DSS Compliance:</strong> All payment information is tokenized and never stored on our servers. We partner with PCI-DSS Level 1 certified payment processors for maximum security.
//                                     </li>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Transaction Analytics:</strong> Purchase patterns and transaction data are analyzed in aggregate form only, with individual customer data never shared with third parties.
//                                     </li>
//                                     <li style={{ marginBottom: '10px' }}>
//                                         <strong>Fraud Prevention:</strong> Real-time fraud detection systems monitor transactions while maintaining customer privacy through advanced encryption techniques.
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '12px',
//                             marginBottom: '15px',
//                         }}>
//                             <h5 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '18px' : '22px',
//                                 color: '#1b5e20',
//                                 textAlign: 'center',
//                                 marginBottom: '15px'
//                             }}>
//                                 🛡️ Enhanced Security Measures for Food Businesses
//                             </h5>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
//                                 gap: '10px',
//                                 fontSize: window.innerWidth < 768 ? '14px' : '15px'
//                             }}>
//                                 <div style={{ padding: '15px', borderRadius: '8px', }}>
//                                     <strong style={{ color: '#2e7d32' }}>🧪 Food Safety Data Encryption</strong>
//                                     <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
//                                         All HACCP logs, temperature readings, and safety checks are encrypted using AES-256 encryption with automated backup to secure cloud storage.
//                                     </p>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '8px',  }}>
//                                     <strong style={{ color: '#2e7d32' }}>📋 Regulatory Compliance Tracking</strong>
//                                     <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
//                                         Automated tracking of FSSAI regulations, health department requirements, and food safety standards with real-time compliance alerts.
//                                     </p>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '8px', }}>
//                                     <strong style={{ color: '#2e7d32' }}>👥 Staff Access Controls</strong>
//                                     <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
//                                         Role-based access with biometric authentication for sensitive areas like recipe databases and customer allergy information.
//                                     </p>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '8px', }}>
//                                     <strong style={{ color: '#2e7d32' }}>🔄 Supply Chain Transparency</strong>
//                                     <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
//                                         Blockchain-based tracking for ingredient sourcing with immutable records for quality assurance and recall management.
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '10px',
//                         }}>
//                             <h5 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                 color: '#e65100',
//                                 marginBottom: '15px'
//                             }}>
//                                 📜 Data Retention & Customer Rights
//                             </h5>
//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '8px',
//                                 marginBottom: '15px',
//                             }}>
//                                 <strong>Data Retention Periods:</strong>
//                                 <ul style={{ paddingLeft: '20px', marginTop: '10px', fontSize: '14px' }}>
//                                     <li>Order history: 7 years for tax purposes</li>
//                                     <li>Customer preferences: 2 years of active use</li>
//                                     <li>Feedback and reviews: 3 years</li>
//                                     <li>Allergy information: Deleted upon customer request or after 1 year of inactivity</li>
//                                     <li>Payment information: Not stored - processed via tokenization</li>
//                                 </ul>
//                             </div>
//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '8px',
//                             }}>
//                                 <strong>Customer Rights:</strong>
//                                 <ul style={{ paddingLeft: '20px', marginTop: '10px', fontSize: '14px' }}>
//                                     <li>Right to access personal data</li>
//                                     <li>Right to correct inaccurate information</li>
//                                     <li>Right to delete personal data (with exceptions for legal requirements)</li>
//                                     <li>Right to data portability</li>
//                                     <li>Right to object to processing</li>
//                                 </ul>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '10px',
//                             marginTop: '10px',
//                             textAlign: 'center'
//                         }}>
//                             <h5 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                 color: '#1565c0',
//                                 marginBottom: '10px'
//                             }}>
//                                 🔐 Our Privacy Commitment to Food & Beverage Vendors
//                             </h5>
//                             <p style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6', color: '#333' }}>
//                                 We understand the unique privacy challenges faced by food and beverage businesses. Our platform is designed with industry-specific security measures, 
//                                 ensuring that your customer data, proprietary recipes, and business operations remain protected while delivering exceptional dining experiences.
//                             </p>
//                             <div style={{ 
//                                 marginTop: '10px', 
//                                 padding: '10px', 
//                                 borderRadius: '8px',
//                                 display: 'inline-block',
//                             }}>
//                                 <strong style={{ color: '#1565c0' }}>24/7 Privacy Support:</strong> Dedicated team available for food safety data emergencies
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         ),

//         "Terms & Conditions": (
//             <div style={{ padding: window.innerWidth < 768 ? '10px' : '10px 10px' }}>
//                 <div style={cardStyle}>
//                     <div style={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         alignItems: 'center',
//                         flexDirection: window.innerWidth < 576 ? 'column' : 'row',
//                         gap: window.innerWidth < 576 ? '10px' : '0'
//                     }}>
//                         <div style={{ width: window.innerWidth < 576 ? '100%' : 'auto' }}>
//                             {/* <h4 style={{ 
//                                 margin: '0 0 10px 0', 
//                                 color: '#A055B0',
//                                 fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                                 textAlign: window.innerWidth < 576 ? 'center' : 'left'
//                             }}>
//                                 Terms & Conditions 
//                             </h4> */}
//                         </div>
//                     </div>

//                     <div style={{ marginTop: '20px', padding: '15px', borderRadius: '8px' }}>
//                         <CustomTerms 
//                             onNext={(data) => {
//                                 console.log("Terms & Conditions submitted:", data);
//                                 setComplianceData(prev => ({
//                                     ...prev,
//                                     termsConditions: { 
//                                         ...prev.termsConditions, 
//                                         status: "compliant",
//                                         lastUpdated: new Date().toISOString().split('T')[0],
//                                         agreed: true,
//                                         agreedDate: new Date().toISOString(),
//                                         submissionId: data.submissionId
//                                     }
//                                 }));
//                                 // Navigate to Vendor Guidelines tab
//                                 setActiveTab("Vendor Guidelines");
//                             }}
//                             onBack={() => {
//                                 setActiveTab("Privacy Policy");
//                             }}
//                             autoAgree={termsTabJustOpened}
//                         />
//                     </div>
//                 </div>
//             </div>
//         ),

//         "Vendor Guidelines": (
//             <div style={{ padding: window.innerWidth < 768 ? '10px' : '5px 10px' ,marginTop:"5px"}}>
//                 <div style={cardStyle}>
//                     <div style={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         alignItems: 'center',
//                         flexDirection: window.innerWidth < 576 ? 'column' : 'row',
//                         gap: window.innerWidth < 576 ? '10px' : '0'
//                     }}>
//                         {/* Content removed as per requirements */}
//                     </div>
                    
//                     <div style={{ marginTop: '20px' }}>
//                         <h5 style={{ 
//                             fontSize: window.innerWidth < 768 ? '18px' : '22px', 
//                             color: '#2e7d32',
//                             textAlign: 'center',
//                             marginBottom: '10px',
//                             paddingBottom: '15px',
//                             borderBottom: '3px solid #2e7d32'
//                         }}>
//                             <FaUtensils aria-hidden="true" style={{ marginRight: '15px' }} />
//                             Food & Beverages Vendor Excellence Standards
//                         </h5>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '12px',
//                             marginBottom: '10px',
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                                 color: '#e65100',
//                                 marginBottom: '10px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 🍳 Food Safety & Hygiene Standards
//                             </h6>
                            
//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '10px',
//                                 marginBottom: '10px',
//                             }}>
//                                 <h6 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                     color: '#d84315',
//                                     marginBottom: '15px',
//                                     display: 'flex',
//                                     alignItems: 'center'
//                                 }}>
//                                     <FaShieldAlt aria-hidden="true" style={{ marginRight: '10px' }} />
//                                     HACCP Compliance Requirements
//                                 </h6>
//                                 <ul style={{ paddingLeft: '20px', marginBottom: '15px', fontSize: '14px' }}>
//                                     <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                         <strong>Temperature Control:</strong> All refrigeration units must maintain temperatures below 5°C (41°F). Freezers must be at -18°C (0°F) or lower. Temperature logs must be maintained every 4 hours.
//                                     </li>
//                                     <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                         <strong>Food Storage:</strong> Raw and cooked foods must be stored separately. All food items must be labeled with preparation date and use-by date.
//                                     </li>
//                                     <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                         <strong>Cross-Contamination Prevention:</strong> Color-coded cutting boards and utensils for different food types. Separate preparation areas for allergen-free meals.
//                                     </li>
//                                     <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                         <strong>Cooking Temperatures:</strong> Poultry: 74°C (165°F), Ground meats: 71°C (160°F), Pork: 63°C (145°F), Seafood: 63°C (145°F).
//                                     </li>
//                                 </ul>
//                             </div>

//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '10px',
//                                 marginBottom: '10px',
//                             }}>
//                                 <h6 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                     color: '#d84315',
//                                     marginBottom: '15px',
//                                     display: 'flex',
//                                     alignItems: 'center'
//                                 }}>
//                                     👨‍🍳 Staff Hygiene & Training
//                                 </h6>
//                                 <div style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
//                                     gap: '15px',
//                                     marginBottom: '15px'
//                                 }}>
//                                     <div style={{ padding: '15px', borderRadius: '8px',  }}>
//                                         <strong style={{ color: '#e65100' }}>Personal Hygiene</strong>
//                                         <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                             <li>Hand washing every 30 minutes</li>
//                                             <li>Clean uniforms daily</li>
//                                             <li>Hair restraints mandatory</li>
//                                             <li>No jewelry in food areas</li>
//                                         </ul>
//                                     </div>
//                                     <div style={{ padding: '15px', borderRadius: '8px',  }}>
//                                         <strong style={{ color: '#e65100' }}>Health Requirements</strong>
//                                         <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                             <li>Annual medical examinations</li>
//                                             <li>No working with infectious diseases</li>
//                                             <li>Regular health declaration</li>
//                                             <li>Vaccination records maintained</li>
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '12px',
//                             marginBottom: '10px',
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                                 color: '#2e7d32',
//                                 marginBottom: '20px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 🥘 Quality & Consistency Standards
//                             </h6>
                            
//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '10px',
//                                 marginBottom: '10px',
//                             }}>
//                                 <h6 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                     color: '#388e3c',
//                                     marginBottom: '10px'
//                                 }}>
//                                     Ingredient Quality Control
//                                 </h6>
//                                 <div style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(3, 1fr)',
//                                     gap: '15px',
//                                     marginBottom: '10px'
//                                 }}>
//                                     <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
//                                         <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>100%</div>
//                                         <div style={{ fontSize: '12px', color: '#666' }}>Fresh Ingredients Only</div>
//                                     </div>
//                                     <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
//                                         <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>24h</div>
//                                         <div style={{ fontSize: '12px', color: '#666' }}>Delivery-to-Use Window</div>
//                                     </div>
//                                     <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
//                                         <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>5⭐</div>
//                                         <div style={{ fontSize: '12px', color: '#666' }}>Supplier Rating Minimum</div>
//                                     </div>
//                                 </div>
                                
//                                 <div style={{ 
//                                     padding: '10px', 
//                                     borderRadius: '8px',
//                                     fontSize: '14px',
//                                 }}>
//                                     <strong>Ingredient Specifications:</strong>
//                                     <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
//                                         <li>Vegetables: Washed and sanitized within 2 hours of receipt</li>
//                                         <li>Meat & Poultry: From approved suppliers with traceability certificates</li>
//                                         <li>Seafood: Fresh only, delivered daily with temperature certification</li>
//                                         <li>Spices & Herbs: Organic preferred, stored in airtight containers</li>
//                                     </ul>
//                                 </div>
//                             </div>

//                             <div style={{ 
//                                 padding: '00px', 
//                                 borderRadius: '10px',
//                             }}>
//                                 <h6 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                     color: '#388e3c',
//                                     marginBottom: '15px'
//                                 }}>
//                                     Portion Control & Presentation
//                                 </h6>
//                                 <div style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
//                                     gap: '15px'
//                                 }}>
//                                     <div style={{ padding: '10px', borderRadius: '8px',  }}>
//                                         <strong style={{ color: '#388e3c' }}>Standardized Portions</strong>
//                                         <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
//                                             All dishes must follow standardized portion sizes (±5% variance). Regular calibration of measuring equipment required.
//                                         </p>
//                                     </div>
//                                     <div style={{ padding: '10px', borderRadius: '8px',  }}>
//                                         <strong style={{ color: '#388e3c' }}>Presentation Standards</strong>
//                                         <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
//                                             Consistent plating, garnish placement, and service ware. Daily quality control checks with photo documentation.
//                                         </p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '12px',
//                             marginBottom: '5px',
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                                 color: '#1565c0',
//                                 marginBottom: '5px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 ⏱️ Service & Operational Excellence
//                             </h6>
                            
//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '10px',
//                                 marginBottom: '5px',
//                             }}>
//                                 <div style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(3, 1fr)',
//                                     gap: '15px',
//                                     marginBottom: '10px'
//                                 }}>
//                                     <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
//                                         <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>15</div>
//                                         <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Order Acknowledgment</div>
//                                     </div>
//                                     <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
//                                         <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>30</div>
//                                         <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Preparation Time Max</div>
//                                     </div>
//                                     <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px', }}>
//                                         <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>99%</div>
//                                         <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Order Accuracy Required</div>
//                                     </div>
//                                 </div>
                                
//                                 <div style={{ 
//                                     padding: '10px', 
//                                     borderRadius: '8px',
//                                     fontSize: '14px',
//                                 }}>
//                                     <strong>Customer Service Protocol:</strong>
//                                     <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
//                                         <li>Phone answered within 3 rings during business hours</li>
//                                         <li>Email responses within 2 hours during business hours</li>
//                                         <li>Online order confirmation within 10 minutes</li>
//                                         <li>Special requests acknowledged and documented</li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '12px',
//                             marginBottom: '5px',
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                                 color: '#7b1fa2',
//                                 marginBottom: '5px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 📋 Compliance & Documentation
//                             </h6>
                            
//                             <div style={{ 
//                                 padding: '10px', 
//                                 borderRadius: '10px',
//                             }}>
//                                 <div style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
//                                     gap: '15px'
//                                 }}>
//                                     <div style={{ padding: '10px', borderRadius: '8px',  }}>
//                                         <strong style={{ color: '#7b1fa2' }}>Required Licenses</strong>
//                                         <ul style={{ paddingLeft: '15px', marginTop: '5px', fontSize: '13px' }}>
//                                             <li>FSSAI License (Valid)</li>
//                                             <li>Health Trade License</li>
//                                             <li>Fire Safety Certificate</li>
//                                             <li>GST Registration</li>
//                                             <li>Shop & Establishment Act</li>
//                                         </ul>
//                                     </div>
//                                     <div style={{ padding: '10px', borderRadius: '8px', }}>
//                                         <strong style={{ color: '#7b1fa2' }}>Mandatory Documentation</strong>
//                                         <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                             <li>Daily Temperature Logs</li>
//                                             <li>Staff Training Records</li>
//                                             <li>Supplier Certificates</li>
//                                             <li>Pest Control Reports</li>
//                                             <li>Equipment Maintenance Logs</li>
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '12px',
//                             marginTop: '10px',
//                             textAlign: 'center'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '18px' : '22px',
//                                 color: '#ff6f00',
//                                 marginBottom: '10px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center'
//                             }}>
//                                 <FaStar aria-hidden="true" style={{ marginRight: '15px' }} />
//                                 Performance Metrics & Reviews
//                             </h6>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(4, 1fr)',
//                                 gap: '15px',
//                                 marginBottom: '10px'
//                             }}>
//                                 <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px', }}>
//                                     <div style={{ fontSize: '28px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>4.5⭐</div>
//                                     <div style={{ fontSize: '14px', color: '#666' }}>Minimum Customer Rating</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px', }}>
//                                     <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>95%</div>
//                                     <div style={{ fontSize: '14px', color: '#666' }}>Order Accuracy Required</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px', }}>
//                                     <div style={{ fontSize: '28px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>30min</div>
//                                     <div style={{ fontSize: '14px', color: '#666' }}>Max Preparation Time</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
//                                     <div style={{ fontSize: '28px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>48h</div>
//                                     <div style={{ fontSize: '14px', color: '#666' }}>Complaint Resolution Time</div>
//                                 </div>
//                             </div>
                            
//                             <div style={{ 
//                                 marginTop: '10px', 
//                                 padding: '10px', 
//                                 borderRadius: '8px',
//                                 textAlign: 'center',
//                             }}>
//                                 <p style={{ margin: 0, fontSize: window.innerWidth < 768 ? '14px' : '16px', fontWeight: 'bold', color: '#d84315' }}>
//                                     ⚠️ Compliance Note: Vendors maintaining below 4.0 rating for 3 consecutive months will undergo mandatory retraining. 
//                                     Ratings below 3.5 for 2 months may result in temporary suspension.
//                                 </p>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '10px', 
//                             borderRadius: '12px',
//                             marginTop: '5px',
//                             textAlign: 'center',
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                                 color: '#2e7d32',
//                                 marginBottom: '5px'
//                             }}>
//                                 🎯 Continuous Improvement Program
//                             </h6>
//                             <p style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px', color: '#333', marginBottom: '10px' }}>
//                                 Monthly performance reviews with improvement action plans. Quarterly mystery shopping evaluations. 
//                                 Annual comprehensive audit with certification renewal.
//                             </p>
//                             <button 
//                                 style={{
//                                     backgroundColor: '#4CAF50',
//                                     color: 'white',
//                                     border: 'none',
//                                     padding: '12px 10px',
//                                     borderRadius: '50px',
//                                     cursor: 'pointer',
//                                     fontSize: '16px',
//                                     fontWeight: 'bold',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     gap: '10px'
//                                 }}
//                             >
//                                 <FaChartLine aria-hidden="true" /> Download Full Guidelines PDF
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         ),

//         "Compliance Status": (
//             <div style={{ padding: window.innerWidth < 768 ? '10px' : '10px 10px' }}>
//                 <div style={cardStyle}>
//                     <h3 style={{ 
//                         color: '#A055B0', 
//                         marginBottom: '25px',
//                         fontSize: window.innerWidth < 768 ? '20px' : '24px',
//                         textAlign: 'center',
//                         paddingBottom: '15px',
//                         borderBottom: '3px solid #A055B0'
//                     }}>
//                         <FaChartBar aria-hidden="true" style={{ marginRight: '15px' }} />
//                         Food & Beverages Compliance Dashboard
//                     </h3>

//                     <div style={{ 
//                         padding: '25px', 
//                         borderRadius: '12px',
//                         marginBottom: '30px',
//                     }}>
//                         <div style={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             flexDirection: window.innerWidth < 768 ? 'column' : 'row',
//                             gap: window.innerWidth < 768 ? '15px' : '0'
//                         }}>
//                             <div style={{ textAlign: window.innerWidth < 768 ? 'center' : 'left' }}>
//                                 <h4 style={{ 
//                                     fontSize: window.innerWidth < 768 ? '18px' : '22px',
//                                     color: '#2e7d32',
//                                     marginBottom: '10px'
//                                 }}>
//                                     <FaChartPie aria-hidden="true" style={{ marginRight: '10px' }} />
//                                     Overall Food Safety Compliance Score
//                                 </h4>
//                                 <p style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px', color: '#555' }}>
//                                     Based on comprehensive assessment of food safety, hygiene, quality standards, and operational excellence
//                                 </p>
//                             </div>
//                             <div style={{
//                                 textAlign: 'center',
//                                 padding: '20px',
//                                 borderRadius: '10px',
//                                 minWidth: window.innerWidth < 768 ? '100%' : '200px',
//                             }}>
//                                 <div style={{
//                                     fontSize: window.innerWidth < 768 ? '36px' : '48px',
//                                     fontWeight: 'bold',
//                                     color: '#4CAF50',
//                                     marginBottom: '5px'
//                                 }}>
//                                     94%
//                                 </div>
//                                 <div style={{ 
//                                     fontSize: window.innerWidth < 768 ? '14px' : '16px',
//                                     color: '#666'
//                                 }}>
//                                     Excellent Compliance
//                                 </div>
//                                 <div style={{
//                                     fontSize: '12px',
//                                     color: '#4CAF50',
//                                     marginTop: '5px',
//                                     fontWeight: 'bold'
//                                 }}>
//                                     ▲ 2% from last month
//                                 </div>
//                             </div>
//                         </div>
                        
//                         <div style={{ marginTop: '25px' }}>
//                             <div style={{ marginBottom: '15px' }}>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     justifyContent: 'space-between',
//                                     marginBottom: '5px'
//                                 }}>
//                                     <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                         <FaUtensils aria-hidden="true" style={{ marginRight: '5px', color: '#4CAF50' }} />
//                                         Food Safety Standards
//                                     </span>
//                                     <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#4CAF50' }}>96%</span>
//                                 </div>
//                                 <div style={{
//                                     height: '10px',
//                                     backgroundColor: '#e0e0e0',
//                                     borderRadius: '5px',
//                                     overflow: 'hidden'
//                                 }}>
//                                     <div style={{
//                                         width: '96%',
//                                         height: '100%',
//                                         backgroundColor: '#4CAF50',
//                                         borderRadius: '5px'
//                                     }}></div>
//                                 </div>
//                             </div>
                            
//                             <div style={{ marginBottom: '15px' }}>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     justifyContent: 'space-between',
//                                     marginBottom: '5px'
//                                 }}>
//                                     <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                         <FaShieldAlt aria-hidden="true" style={{ marginRight: '5px', color: '#2196F3' }} />
//                                         Hygiene & Sanitation
//                                     </span>
//                                     <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#2196F3' }}>92%</span>
//                                 </div>
//                                 <div style={{
//                                     height: '10px',
//                                     backgroundColor: '#e0e0e0',
//                                     borderRadius: '5px',
//                                     overflow: 'hidden'
//                                 }}>
//                                     <div style={{
//                                         width: '92%',
//                                         height: '100%',
//                                         backgroundColor: '#2196F3',
//                                         borderRadius: '5px'
//                                     }}></div>
//                                 </div>
//                             </div>
                            
//                             <div style={{ marginBottom: '15px' }}>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     justifyContent: 'space-between',
//                                     marginBottom: '5px'
//                                 }}>
//                                     <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                         <FaStar aria-hidden="true" style={{ marginRight: '5px', color: '#FF9800' }} />
//                                         Quality Control
//                                     </span>
//                                     <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#FF9800' }}>91%</span>
//                                 </div>
//                                 <div style={{
//                                     height: '10px',
//                                     backgroundColor: '#e0e0e0',
//                                     borderRadius: '5px',
//                                     overflow: 'hidden'
//                                 }}>
//                                     <div style={{
//                                         width: '91%',
//                                         height: '100%',
//                                         backgroundColor: '#FF9800',
//                                         borderRadius: '5px'
//                                     }}></div>
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '15px' }}>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     justifyContent: 'space-between',
//                                     marginBottom: '5px'
//                                 }}>
//                                     <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                         <FaClipboardCheck aria-hidden="true" style={{ marginRight: '5px', color: '#9C27B0' }} />
//                                         Operational Excellence
//                                     </span>
//                                     <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#9C27B0' }}>88%</span>
//                                 </div>
//                                 <div style={{
//                                     height: '10px',
//                                     backgroundColor: '#e0e0e0',
//                                     borderRadius: '5px',
//                                     overflow: 'hidden'
//                                 }}>
//                                     <div style={{
//                                         width: '88%',
//                                         height: '100%',
//                                         backgroundColor: '#9C27B0',
//                                         borderRadius: '5px'
//                                     }}></div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         marginBottom: '30px',
//                         padding: '20px',
//                         borderRadius: '10px',
//                     }}>
//                         <h4 style={{ 
//                             fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                             color: '#333',
//                             marginBottom: '15px',
//                             textAlign: 'center'
//                         }}>
//                             🍽️ Food & Beverages Compliance Categories
//                         </h4>
//                         <div style={{
//                             display: 'grid',
//                             gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(4, 1fr)',
//                             gap: '15px',
//                             marginBottom: '20px'
//                         }}>
//                             {[
//                                 { 
//                                     id: 'food-safety', 
//                                     name: 'Food Safety', 
//                                     description: 'Temperature control, storage, handling',
//                                     icon: <FaShieldAlt aria-hidden="true" />, 
//                                     color: '#4CAF50',
//                                     score: '96%'
//                                 },
//                                 { 
//                                     id: 'hygiene', 
//                                     name: 'Hygiene Standards', 
//                                     description: 'Staff hygiene, sanitation, cleaning',
//                                     icon: <FaUsers aria-hidden="true" />, 
//                                     color: '#2196F3',
//                                     score: '92%'
//                                 },
//                                 { 
//                                     id: 'quality', 
//                                     name: 'Quality Control', 
//                                     description: 'Ingredients, preparation, consistency',
//                                     icon: <FaStar aria-hidden="true" />, 
//                                     color: '#FF9800',
//                                     score: '91%'
//                                 },
//                                 { 
//                                     id: 'operations', 
//                                     name: 'Operations', 
//                                     description: 'Service, documentation, training',
//                                     icon: <FaClipboardCheck aria-hidden="true" />, 
//                                     color: '#9C27B0',
//                                     score: '88%'
//                                 }
//                             ].map(category => (
//                                 <div 
//                                     key={category.id}
//                                     style={{
//                                         padding: '20px',
//                                         borderRadius: '8px',
//                                         textAlign: 'center',
//                                         border: `1px solid ${category.color}`,
//                                         transition: 'all 0.3s ease',
//                                         cursor: 'pointer'
//                                     }}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'translateY(-5px)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'translateY(0)';
//                                     }}
//                                     onClick={() => alert(`View ${category.name} details`)}
//                                 >
//                                     <div style={{ 
//                                         fontSize: '32px', 
//                                         color: category.color,
//                                         marginBottom: '15px'
//                                     }}>
//                                         {category.icon}
//                                     </div>
//                                     <div style={{ 
//                                         fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                                         fontWeight: 'bold',
//                                         color: '#333',
//                                         marginBottom: '8px'
//                                     }}>
//                                         {category.name}
//                                     </div>
//                                     <div style={{ 
//                                         fontSize: window.innerWidth < 768 ? '12px' : '13px',
//                                         color: '#666',
//                                         marginBottom: '15px',
//                                         minHeight: '40px'
//                                     }}>
//                                         {category.description}
//                                     </div>
//                                     <div style={{
//                                         fontSize: '24px',
//                                         fontWeight: 'bold',
//                                         color: category.color,
//                                         padding: '8px',
//                                         borderRadius: '6px'
//                                     }}>
//                                         {category.score}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     <div style={{ 
//                         display: 'grid', 
//                         gridTemplateColumns: window.innerWidth < 768 ? '1fr' : window.innerWidth < 992 ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', 
//                         gap: '20px', 
//                         marginBottom: '30px' 
//                     }}>
//                         {[
//                             { 
//                                 title: "Temperature Control", 
//                                 status: "compliant", 
//                                 score: "98%",
//                                 icon: <FaCheckCircle aria-hidden="true" />,
//                                 color: "#4CAF50",
//                                 lastCheck: "Today",
//                                 details: "Refrigeration, cooking, holding temperatures",
//                                 trend: "▲ 1%"
//                             },
//                             { 
//                                 title: "Staff Hygiene", 
//                                 status: "compliant", 
//                                 score: "95%",
//                                 icon: <FaClipboardCheck aria-hidden="true" />,
//                                 color: "#4CAF50",
//                                 lastCheck: "2 days ago",
//                                 details: "Hand washing, uniform, health checks",
//                                 trend: "▲ 2%"
//                             },
//                             { 
//                                 title: "Ingredient Quality", 
//                                 status: "compliant", 
//                                 score: "96%",
//                                 icon: <FaStar aria-hidden="true" />,
//                                 color: "#4CAF50",
//                                 lastCheck: "Yesterday",
//                                 details: "Freshness, sourcing, storage",
//                                 trend: "▲ 3%"
//                             },
//                             { 
//                                 title: "Food Storage", 
//                                 status: "pending", 
//                                 score: "88%",
//                                 icon: <FaClock aria-hidden="true" />,
//                                 color: "#FFC107",
//                                 lastCheck: "1 week ago",
//                                 details: "FIFO, labeling, segregation",
//                                 trend: "▼ 2%"
//                             },
//                             { 
//                                 title: "Preparation Standards", 
//                                 status: "compliant", 
//                                 score: "94%",
//                                 icon: <FaCheckCircle aria-hidden="true" />,
//                                 color: "#4CAF50",
//                                 lastCheck: "3 days ago",
//                                 details: "Cooking methods, cross-contamination",
//                                 trend: "▲ 1%"
//                             },
//                             { 
//                                 title: "Cleaning Procedures", 
//                                 status: "attention", 
//                                 score: "82%",
//                                 icon: <FaExclamationCircle aria-hidden="true" />,
//                                 color: "#f44336",
//                                 lastCheck: "2 weeks ago",
//                                 details: "Sanitization, equipment cleaning",
//                                 trend: "▼ 5%"
//                             },
//                             { 
//                                 title: "Allergen Management", 
//                                 status: "compliant", 
//                                 score: "97%",
//                                 icon: <FaShieldAlt aria-hidden="true" />,
//                                 color: "#4CAF50",
//                                 lastCheck: "Today",
//                                 details: "Labeling, preparation zones",
//                                 trend: "▲ 4%"
//                             },
//                             { 
//                                 title: "Documentation", 
//                                 status: "pending", 
//                                 score: "86%",
//                                 icon: <FaClock aria-hidden="true" />,
//                                 color: "#FFC107",
//                                 lastCheck: "5 days ago",
//                                 details: "Logs, records, certificates",
//                                 trend: "▼ 3%"
//                             },
//                             { 
//                                 title: "Waste Management", 
//                                 status: "compliant", 
//                                 score: "93%",
//                                 icon: <FaCheckCircle aria-hidden="true" />,
//                                 color: "#4CAF50",
//                                 lastCheck: "4 days ago",
//                                 details: "Disposal, recycling, segregation",
//                                 trend: "▲ 2%"
//                             }
//                         ].map((item, index) => (
//                             <div 
//                                 key={index} 
//                                 style={{
//                                     ...dashboardCardStyle,
//                                     borderLeft: `5px solid ${item.color}`,
//                                     padding: '20px',
//                                     transition: 'all 0.3s ease',
//                                     cursor: 'pointer',
//                                     position: 'relative'
//                                 }}
//                                 onMouseEnter={(e) => {
//                                     e.currentTarget.style.transform = 'translateY(-5px)';
//                                 }}
//                                 onMouseLeave={(e) => {
//                                     e.currentTarget.style.transform = 'translateY(0)';
//                                 }}
//                                 onClick={() => alert(`View details for ${item.title}`)}
//                             >
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     justifyContent: 'space-between', 
//                                     alignItems: 'flex-start',
//                                     marginBottom: '15px'
//                                 }}>
//                                     <div style={{ flex: 1 }}>
//                                         <h5 style={{ 
//                                             margin: '0 0 5px 0', 
//                                             color: '#333',
//                                             fontSize: window.innerWidth < 768 ? '14px' : '16px',
//                                             fontWeight: 'bold'
//                                         }}>
//                                             {item.title}
//                                         </h5>
//                                         <div style={{ 
//                                             display: 'flex', 
//                                             alignItems: 'center',
//                                             marginBottom: '5px'
//                                         }}>
//                                             <span style={{ 
//                                                 color: item.color,
//                                                 fontWeight: 'bold',
//                                                 fontSize: window.innerWidth < 768 ? '18px' : '22px',
//                                                 marginRight: '10px'
//                                             }}>
//                                                 {item.score}
//                                             </span>
//                                             <span style={{ 
//                                                 color: item.color,
//                                                 padding: '3px 8px',
//                                                 borderRadius: '12px',
//                                                 fontSize: '11px',
//                                                 fontWeight: 'bold',
//                                                 textTransform: 'uppercase'
//                                             }}>
//                                                 {item.status}
//                                             </span>
//                                         </div>
//                                         <div style={{ 
//                                             fontSize: '12px',
//                                             color: '#666',
//                                             marginTop: '8px',
//                                             lineHeight: '1.4'
//                                         }}>
//                                             {item.details}
//                                         </div>
//                                     </div>
//                                     <div style={{ 
//                                         fontSize: '24px', 
//                                         color: item.color,
//                                         marginLeft: '10px'
//                                     }}>
//                                         {item.icon}
//                                     </div>
//                                 </div>
                                
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center',
//                                     fontSize: '12px',
//                                     color: '#666',
//                                     marginTop: '15px',
//                                     paddingTop: '10px',
//                                     borderTop: '1px solid #f0f0f0'
//                                 }}>
//                                     <div style={{ display: 'flex', alignItems: 'center' }}>
//                                         <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '5px', fontSize: '10px' }} />
//                                         Checked: {item.lastCheck}
//                                     </div>
//                                     <div style={{
//                                         color: item.trend.startsWith('▲') ? '#4CAF50' : 
//                                                item.trend.startsWith('▼') ? '#f44336' : '#666',
//                                         fontWeight: 'bold'
//                                     }}>
//                                         {item.trend}
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     <div style={{ 
//                         padding: '25px', 
//                         borderRadius: '12px',
//                         marginBottom: '30px',
//                     }}>
//                         <h4 style={{ 
//                             fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                             color: '#1565c0',
//                             marginBottom: '20px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             <FaCalendarCheck aria-hidden="true" style={{ marginRight: '10px' }} />
//                             Upcoming Food Safety Audits & Inspections
//                         </h4>
                        
//                         <div style={{
//                             display: 'grid',
//                             gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
//                             gap: '15px'
//                         }}>
//                             {[
//                                 { 
//                                     title: "FSSAI Annual Inspection", 
//                                     date: "2024-04-15", 
//                                     status: "scheduled",
//                                     type: "Regulatory",
//                                     priority: "high",
//                                     inspector: "Food Safety Officer",
//                                     location: "Main Kitchen"
//                                 },
//                                 { 
//                                     title: "Kitchen Hygiene Audit", 
//                                     date: "2024-04-22", 
//                                     status: "scheduled",
//                                     type: "Internal",
//                                     priority: "medium",
//                                     inspector: "Quality Manager",
//                                     location: "All Areas"
//                                 },
//                                 { 
//                                     title: "Staff Training Assessment", 
//                                     date: "2024-05-01", 
//                                     status: "pending",
//                                     type: "Training",
//                                     priority: "medium",
//                                     inspector: "Training Department",
//                                     location: "Training Room"
//                                 },
//                                 { 
//                                     title: "Supplier Quality Review", 
//                                     date: "2024-05-10", 
//                                     status: "planned",
//                                     type: "Vendor",
//                                     priority: "high",
//                                     inspector: "Procurement Team",
//                                     location: "Storage & Kitchen"
//                                 }
//                             ].map((audit, index) => (
//                                 <div 
//                                     key={index}
//                                     style={{
//                                         padding: '20px',
//                                         borderRadius: '8px',
//                                         border: '1px solid #e0e0e0'
//                                     }}
//                                 >
//                                     <div style={{ 
//                                         display: 'flex', 
//                                         justifyContent: 'space-between',
//                                         alignItems: 'flex-start',
//                                         marginBottom: '10px'
//                                     }}>
//                                         <div>
//                                             <h6 style={{ 
//                                                 margin: 0,
//                                                 fontSize: '16px',
//                                                 fontWeight: 'bold',
//                                                 color: '#333'
//                                             }}>
//                                                 {audit.title}
//                                             </h6>
//                                             <div style={{ 
//                                                 fontSize: '12px',
//                                                 color: '#666',
//                                                 marginTop: '5px'
//                                             }}>
//                                                 Inspector: {audit.inspector} | Location: {audit.location}
//                                             </div>
//                                         </div>
//                                         <span style={{ 
//                                             color: audit.status === 'scheduled' ? '#2e7d32' : 
//                                                    audit.status === 'pending' ? '#FF9800' : '#2196F3',
//                                             padding: '4px 10px',
//                                             borderRadius: '12px',
//                                             fontSize: '12px',
//                                             fontWeight: 'bold',
//                                             whiteSpace: 'nowrap'
//                                         }}>
//                                             {audit.status.toUpperCase()}
//                                         </span>
//                                     </div>
//                                     <div style={{ 
//                                         display: 'flex', 
//                                         justifyContent: 'space-between',
//                                         alignItems: 'center',
//                                         fontSize: '13px',
//                                         color: '#666',
//                                         marginTop: '15px'
//                                     }}>
//                                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                                             <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '8px', fontSize: '14px' }} />
//                                             <strong>Date:</strong> {audit.date}
//                                         </div>
//                                         <div>
//                                             <span style={{ 
//                                                 color: audit.priority === 'high' ? '#f44336' : 
//                                                        audit.priority === 'medium' ? '#FF9800' : '#4CAF50',
//                                                 padding: '4px 10px',
//                                                 borderRadius: '10px',
//                                                 fontSize: '11px',
//                                                 fontWeight: 'bold'
//                                             }}>
//                                                 {audit.type} | {audit.priority.toUpperCase()} PRIORITY
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '25px', 
//                         borderRadius: '12px',
//                         marginBottom: '30px',
//                     }}>
//                         <h4 style={{ 
//                             fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                             color: '#e65100',
//                             marginBottom: '20px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             <FaClipboardCheck aria-hidden="true" style={{ marginRight: '10px' }} />
//                             Required Actions for Food Safety Compliance
//                         </h4>
                        
//                         <div style={{
//                             display: 'grid',
//                             gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
//                             gap: '15px',
//                             marginBottom: '20px'
//                         }}>
//                             <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     alignItems: 'center',
//                                     marginBottom: '15px'
//                                 }}>
//                                     <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '10px', fontSize: '20px' }} />
//                                     <strong style={{ color: '#f44336', fontSize: '16px' }}>
//                                         Immediate Attention Required (Within 48 hours)
//                                     </strong>
//                                 </div>
//                                 <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
//                                     <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                         <strong>Deep Cleaning Schedule:</strong> Complete overdue deep cleaning of walk-in refrigerator
//                                     </li>
//                                     <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                         <strong>Temperature Logs:</strong> Submit missing temperature logs for March 15-20
//                                     </li>
//                                     <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                         <strong>Staff Training:</strong> 2 kitchen staff need food handler certification renewal
//                                     </li>
//                                     <li style={{ paddingLeft: '10px' }}>
//                                         <strong>Equipment Calibration:</strong> Calibrate meat thermometer by tomorrow
//                                     </li>
//                                 </ul>
//                             </div>
                            
//                             <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     alignItems: 'center',
//                                     marginBottom: '15px'
//                                 }}>
//                                     <FaClock aria-hidden="true" style={{ color: '#FF9800', marginRight: '10px', fontSize: '20px' }} />
//                                     <strong style={{ color: '#FF9800', fontSize: '16px' }}>
//                                         Upcoming Compliance Deadlines
//                                     </strong>
//                                 </div>
//                                 <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
//                                     <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                         <strong>Q1 Safety Report:</strong> Due April 30, 2024
//                                     </li>
//                                     <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                         <strong>Pest Control Service:</strong> Scheduled for May 5, 2024
//                                     </li>
//                                     <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                         <strong>Fire Safety Inspection:</strong> Due May 15, 2024
//                                     </li>
//                                     <li style={{ paddingLeft: '10px' }}>
//                                         <strong>Annual Staff Health Check:</strong> Due June 1, 2024
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
                        
//                         <div style={{ textAlign: 'center' }}>
//                             <button 
//                                 onClick={() => alert("Generate Food Safety Report clicked")}
//                                 style={{
//                                     ...actionButtonStyle,
//                                     backgroundColor: '#4CAF50',
//                                     padding: window.innerWidth < 768 ? '12px 25px' : '15px 40px',
//                                     fontSize: window.innerWidth < 768 ? '14px' : '16px',
//                                     fontWeight: 'bold',
//                                     borderRadius: '50px',
//                                     display: 'inline-flex',
//                                     alignItems: 'center'
//                                 }}
//                                 onMouseEnter={(e) => {
//                                     e.currentTarget.style.backgroundColor = '#388E3C';
//                                     e.currentTarget.style.transform = 'translateY(-2px)';
//                                 }}
//                                 onMouseLeave={(e) => {
//                                     e.currentTarget.style.backgroundColor = '#4CAF50';
//                                     e.currentTarget.style.transform = 'translateY(0)';
//                                 }}
//                             >
//                                 <FaChartBar aria-hidden="true" style={{ marginRight: '10px' }} />
//                                 Generate Food Safety Compliance Report
//                             </button>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '25px', 
//                         borderRadius: '12px',
//                         marginBottom: '30px',
//                     }}>
//                         <h4 style={{ 
//                             fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                             color: '#7b1fa2',
//                             marginBottom: '20px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             <FaChartLine aria-hidden="true" style={{ marginRight: '10px' }} />
//                             Food Safety Performance Metrics
//                         </h4>
                        
//                         <div style={{
//                             display: 'grid',
//                             gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(4, 1fr)',
//                             gap: '15px'
//                         }}>
//                             <div style={{ 
//                                 textAlign: 'center', 
//                                 padding: '20px', 
//                                 borderRadius: '8px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <div style={{ fontSize: '32px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>0</div>
//                                 <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Critical Violations</div>
//                                 <div style={{ fontSize: '12px', color: '#4CAF50', fontWeight: 'bold' }}>This Month</div>
//                             </div>
//                             <div style={{ 
//                                 textAlign: 'center', 
//                                 padding: '20px', 
//                                 borderRadius: '8px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <div style={{ fontSize: '32px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>3</div>
//                                 <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Minor Violations</div>
//                                 <div style={{ fontSize: '12px', color: '#2196F3', fontWeight: 'bold' }}>Resolving</div>
//                             </div>
//                             <div style={{ 
//                                 textAlign: 'center', 
//                                 padding: '20px', 
//                                 borderRadius: '8px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <div style={{ fontSize: '32px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>12</div>
//                                 <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Completed Audits</div>
//                                 <div style={{ fontSize: '12px', color: '#FF9800', fontWeight: 'bold' }}>Last 90 Days</div>
//                             </div>
//                             <div style={{ 
//                                 textAlign: 'center', 
//                                 padding: '20px', 
//                                 borderRadius: '8px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <div style={{ fontSize: '32px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>94%</div>
//                                 <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Compliance Score</div>
//                                 <div style={{ fontSize: '12px', color: '#9C27B0', fontWeight: 'bold' }}>Industry Average: 89%</div>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '25px', 
//                         borderRadius: '12px',
//                         textAlign: 'center'
//                     }}>
//                         <h4 style={{ 
//                             fontSize: window.innerWidth < 768 ? '18px' : '20px',
//                             color: '#2e7d32',
//                             marginBottom: '15px'
//                         }}>
//                             🏆 Compliance Excellence Recognition
//                         </h4>
//                         <p style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px', color: '#333', marginBottom: '20px' }}>
//                             Your establishment maintains <strong>94% compliance score</strong>, placing you in the <strong>top 15%</strong> 
//                             of Food & Beverage businesses on our platform. Keep up the excellent work!
//                         </p>
//                         <div style={{
//                             display: 'flex',
//                             justifyContent: 'center',
//                             gap: '20px',
//                             flexWrap: 'wrap'
//                         }}>
//                             <div style={{ 
//                                 padding: '15px', 
//                                 borderRadius: '8px',
//                                 minWidth: '150px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Current Streak</div>
//                                 <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>180</div>
//                                 <div style={{ fontSize: '12px', color: '#666' }}>Days without violations</div>
//                             </div>
//                             <div style={{ 
//                                 padding: '15px', 
//                                 borderRadius: '8px',
//                                 minWidth: '150px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Industry Rank</div>
//                                 <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>Top 15%</div>
//                                 <div style={{ fontSize: '12px', color: '#666' }}>Among 500+ restaurants</div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         )
//     };

//     return (
//         <>
//             <div>
//                 <style>{`
//                     .main-container {
//                         padding: 20px;
//                         display: flex;
//                         flex-direction: column;
//                         width: 100%;
//                         max-width: 100%;
//                         overflow-x: hidden;
//                     }

//                     .tabs-wrapper {
//                         display: flex;
//                         flex-direction: column;
//                         align-items: center;
//                         gap: 10px;
//                         margin-left: 0px;
//                         width: 100%;
//                     }

//                     /* Mobile view - Grid layout with full text */
//                     @media (max-width: 767px) {
//                         .tab-buttons {
//                             display: grid !important;
//                             grid-template-columns: repeat(3, 1fr) !important;
//                             gap: 8px !important;
//                             overflow-x: visible !important;
//                             overflow-y: visible !important;
//                             margin-top: ${window.innerWidth < 768 ? '40px' : '123px'} !important;
//                             padding: 10px 5px !important;
//                             width: 100% !important;
//                             -webkit-overflow-scrolling: auto !important;
//                             scrollbar-width: none !important;
//                         }

//                         .tab-button {
//                             flex: 1 !important;
//                             height: 55px !important;
//                             font-size: 14px !important;
//                             padding: 8px 5px !important;
//                             white-space: normal !important;
//                             overflow: visible !important;
//                             text-overflow: unset !important;
//                             min-width: 0 !important;
//                             max-width: 100% !important;
//                             margin: 0 !important;
//                             display: flex !important;
//                             align-items: center !important;
//                             justify-content: center !important;
//                             text-align: center !important;
//                             line-height: 1.3 !important;
//                             word-break: break-word !important;
//                             hyphens: auto !important;
//                         }
//                     }

//                     /* Small mobile screens */
//                     @media (max-width: 400px) {
//                         .tab-button {
//                             font-size: 13px !important;
//                             height: 40px !important;
//                             padding: 6px 4px !important;
//                         }
//                     }

//                     /* Medium mobile screens */
//                     @media (min-width: 401px) and (max-width: 480px) {
//                         .tab-button {
//                             font-size: 13px !important;
//                             height: 40px !important;
//                         }
//                     }

//                     /* Large mobile screens */
//                     @media (min-width: 481px) and (max-width: 767px) {
//                         .tab-button {
//                             font-size: 15px !important;
//                             height: 50px !important;
//                         }
//                     }

//                     /* Tablet view - Horizontal layout */
//                     @media (min-width: 768px) and (max-width: 991px) {
//                         .tab-buttons {
//                             display: flex !important;
//                             flex-wrap: nowrap !important;
//                             overflow-x: auto !important;
//                             overflow-y: hidden !important;
//                             margin-top: ${window.innerWidth < 768 ? '60px' : '123px'} !important;
//                             padding: 10px 5px !important;
//                             width: 100% !important;
//                             -webkit-overflow-scrolling: touch !important;
//                             scrollbar-width: none !important;
//                             gap: 5px !important;
//                         }

//                         .tab-button {
//                             flex: 0 0 auto !important;
//                             height: 42px !important;
//                             font-size: 13px !important;
//                             padding: 0 15px !important;
//                             white-space: nowrap !important;
//                             overflow: visible !important;
//                             margin: 0 !important;
//                             display: flex !important;
//                             align-items: center !important;
//                             justify-content: center !important;
//                             min-width: max-content !important;
//                         }
//                     }

//                     /* Desktop view - Evenly distributed */
//                     @media (min-width: 992px) {
//                         .tab-buttons {
//                             display: flex !important;
//                             justify-content: space-between !important;
//                             overflow-x: visible !important;
//                             gap: 5px !important;
//                             margin-top: ${window.innerWidth < 768 ? '60px' : '123px'} !important;
//                             padding: 10px 5px !important;
//                             width: 100% !important;
//                         }
                        
//                         .tab-button {
//                             flex: 1 !important;
//                             min-width: 0 !important;
//                             padding: 0 5px !important;
//                             height: 45px !important;
//                             font-size: 14px !important;
//                             // white-space: nowrap !important;
//                             // overflow: hidden !important;
//                             // text-overflow: ellipsis !important;
//                         }
//                     }
//                         @media(min-width:1000px){
//                         .tab-button{
//                         font-size: 16px !important;
//                         }
//                         }

//                     .tab-buttons::-webkit-scrollbar {
//                         display: none;
//                     }

//                     .tab-button {
//                         border: none;
//                         border-radius: 8px;
//                         background-color: #d9d9d9;
//                         color: #000;
//                         font-weight: 500;
//                         cursor: pointer;
//                         transition: background-color 0.3s ease;
//                     }

//                     .tab-button.active {
//                         background-color: #b15cd6;
//                         color: white;
//                     }

//                     .tab-content {
//                         margin-top: 0px;
//                         width: 100%;
//                         overflow-x: hidden;
//                         overflow-y: auto;
//                     }

//                     .tab-content::-webkit-scrollbar {
//                         width: 4px;
//                         height: 4px;
//                     }

//                     .tab-content::-webkit-scrollbar-track {
//                         background: #f0f0f0;
//                     }

//                     .tab-content::-webkit-scrollbar-thumb {
//                         background: #b15cd6;
//                         border-radius: 10px;
//                     }

//                     .sidebar {
//                         margin-top: 30px;
//                         max-height: 600px;
//                         overflow-y: auto;
//                     }

//                     .card {
//                         width: 100%;
//                         max-width: 300px;
//                         height: 120px;
//                         background: #ccc;
//                         border-radius: 8px;
//                         margin: 10px auto;
//                         position: relative;
//                         padding: 10px;
//                     }

//                     @media (max-width: 576px) {
//                         .container-fluid {
//                             padding-left: 5px;
//                             padding-right: 5px;
//                         }

//                         .col-lg-7, .col-lg-3 {
//                             padding-left: 5px;
//                             padding-right: 5px;
//                         }
//                     }

//                     @media (min-width: 576px) and (max-width: 768px) {
//                         .tab-button {
//                             height: 45px;
//                         }
//                     }

//                     @media (min-width: 768px) and (max-width: 992px) {
//                         .tab-button {
//                             font-size: 13px;
//                             padding: 0 8px;
//                         }
//                     }

//                     @media (min-width: 992px) {
//                         .left-column {
//                             width: 100%;
//                             padding-right: 95px;
//                             max-height: 700px;
//                         }

//                         .right-column {
//                             width: 30%;
//                             position: sticky;
//                             top: -30px;
//                             max-height: 700px;
//                             overflow-y: auto;
//                         }
//                     }

//                     @media (max-width : 991px) {
//                         .hideits {
//                             display: none !important;
//                         }
//                     }

//                     .sidebar::-webkit-scrollbar,
//                     .left-column::-webkit-scrollbar {
//                         width: 0px;
//                         background: transparent;
//                     }

//                     @media (max-width: 768px) {
//                         .company-mobile-data {
//                             height: auto !important;
//                             min-height: calc(100vh - 120px);
//                         }

//                         .profile-mobilescroll {
//                             margin-top: 0 !important;
//                         }
//                     }
//                         @media(max-width:425px){
//                         .tab-buttons{
//                         grid-template-columns: repeat(2, 1fr) !important;
//                         }
//                         }
//                 `}</style>

//                 <div className="container-fluid company-mobile-data" style={{ 
//                     height: "auto", 
//                     minHeight: "500px",
//                     paddingLeft: window.innerWidth < 768 ? '5px' : '15px',
//                     paddingRight: window.innerWidth < 768 ? '5px' : '15px'
//                 }}>
//                     <div className="row" style={{ margin: 0 }}>
//                         <div className="col-lg-2 col-md-1"></div>
//                         <div className="col-lg-7 col-md-8 col-sm-12" style={{ 
//                             paddingLeft: window.innerWidth < 768 ? '5px' : '15px',
//                             paddingRight: window.innerWidth < 768 ? '5px' : '15px'
//                         }}>
//                             <p
//                                 className="breadcrumb maamaas-home-bredcum"
//                                 style={{
//                                     position: "fixed",
//                                 top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px" ,                            
//                                     left: 0,
//                                     width: "100%",
//                                     //backgroundColor: "#fff",
//                                     zIndex: 1000,
//                                     padding: "10px 15px",
//                                     fontSize: window.innerWidth < 576 ? "14px" : window.innerWidth < 768 ? "15px" : "18px",
//                                     fontWeight: "bold",
//                                     textAlign: "center",
//                                     margin: 0,
//                                     //borderBottom: "1px solid #e0e0e0",
//                                     //boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
//                                 }}
//                             >
//                                 <Link
//                                     to="/foodladingpage"
//                                     style={{
//                                         color: "purple",
//                                         fontWeight: "bold",
//                                         textDecoration: "none",
//                                         fontSize: window.innerWidth < 576 ? "14px" : "inherit"
//                                     }}
//                                 >
//                                     Food & Beverages
//                                 </Link>
//                                 <span className="separator" style={{ margin: "0 8px", color: "#666" }}> &gt; </span>
//                                 <span style={{ color: "purple", fontSize: window.innerWidth < 576 ? "14px" : "inherit" }}>
//                                     Legal & Compliance
//                                 </span>
//                                 <span className="separator" style={{ margin: "0 8px", color: "#666" }}> &gt; </span>
//                                 <span style={{ 
//                                     color: "purple", 
//                                     fontWeight: "bold",
//                                     fontSize: window.innerWidth < 576 ? "14px" : "inherit"
//                                 }}>
//                                     {activeTab}
//                                 </span>
//                             </p>

//                             <div className="profile-mobilescroll" style={{ 
//                                 marginTop: window.innerWidth < 768 ? "80px" : "100px",
//                                 width: "100%"
//                             }}>
//                                 <div style={{ width: "100%" }}>
//                                     <div className="tab-buttons">
//                                         {["Privacy Policy", "Terms & Conditions", "Vendor Guidelines", "Compliance Status"].map((label) => (
//                                             <button
//                                                 key={label}
//                                                 className={`tab-button ${activeTab === label ? "active" : ""}`}
//                                                 onClick={() => {
//                                                     setActiveTab(label);
                                                    
//                                                     // Set flag when Terms tab is opened for auto-agree
//                                                     if (label === "Terms & Conditions") {
//                                                         setTermsTabJustOpened(true);
//                                                     } else {
//                                                         setTermsTabJustOpened(false);
//                                                     }
                                                    
//                                                     // Scroll tab content to top
//                                                     const tabContent = document.querySelector('.tab-content');
//                                                     if (tabContent) {
//                                                         tabContent.scrollTop = 0;
//                                                     }
//                                                     // Also scroll page to top for better UX
//                                                     window.scrollTo({
//                                                         top: 0,
//                                                         behavior: 'smooth'
//                                                     });
//                                                     // Scroll tab buttons to make active tab visible (for tablet/desktop)
//                                                     if (window.innerWidth >= 768) {
//                                                         const tabButtons = document.querySelector('.tab-buttons');
//                                                         const activeButton = document.querySelector('.tab-button.active');
//                                                         if (tabButtons && activeButton) {
//                                                             const leftPos = activeButton.offsetLeft - tabButtons.offsetLeft;
//                                                             tabButtons.scrollTo({
//                                                                 left: leftPos - 20,
//                                                                 behavior: 'smooth'
//                                                             });
//                                                         }
//                                                     }
//                                                 }}
//                                             >
//                                                 {label}
//                                             </button>
//                                         ))}
//                                     </div>
//                                     <div
//                                         className="tab-content"
//                                         style={{
//                                             // height: containerHeight,
//                                             // overflowX: "hidden",
//                                             // overflowY: "auto",
//                                             padding: window.innerWidth < 768 ? "5px" : "0",
//                                             marginTop: "0px"
//                                         }}
//                                     >
//                                         {tabContent[activeTab]}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-lg-3 col-md-3 hideits" style={{ 
//                             paddingLeft: window.innerWidth < 992 ? '5px' : '15px',
//                             paddingRight: window.innerWidth < 992 ? '5px' : '15px'
//                         }}>
//                             <Foodandbeveragesadvertise />
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <DocumentViewerModal 
//                 isOpen={showDocumentViewer}
//                 onClose={handleCloseDocumentViewer}
//                 title={currentDocument.title}
//                 content={currentDocument.content}
//             />
//         </>
//     );
// };

// // Styles
// const cardStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "10px",
//     padding: window.innerWidth < 768 ? "15px" : "20px",
//     marginBottom: "20px",
//     width: "100%",
//     border: "1px solid #e0e0e0",
//     height:window.innerHeight<600 ? "60vh" :"65vh",
//      overflow:"auto"
    
// };

// const dashboardCardStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     padding: "15px",
//     minHeight: "100px",
//     border: "1px solid #e0e0e0"
// };

// const actionButtonStyle = {
//     backgroundColor: "#2196F3",
//     color: "white",
//     border: "none",
//     padding: "8px 15px",
//     borderRadius: "5px",
//     cursor: "pointer",
//     display: 'inline-flex',
//     alignItems: "center",
//     gap: "8px",
//     fontSize: "14px",
//     fontWeight: "bold",
//     whiteSpace: "nowrap",
//     transition: "all 0.3s ease"
// };

// export default FoodLeagelandcompliance;





import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { 
  FaCheckCircle, 
  FaExclamationTriangle, 
  FaClock, 
  FaDatabase, 
  FaShieldAlt, 
  FaGavel, 
  FaBook, 
  FaTimes, 
  FaUtensils, 
  FaShoppingCart, 
  FaTruck, 
  FaGlassCheers, 
  FaStar, 
  FaUsers, 
  FaChartLine, 
  FaCertificate, 
  FaChartBar, 
  FaChartPie, 
  FaBalanceScale, 
  FaClipboardCheck, 
  FaExclamationCircle, 
  FaCalendarCheck, 
  FaRegCalendarAlt,
  FaArrowRight
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useLoader } from "../../../context/LoaderProvider.jsx";
import Foodandbeveragesadvertise from './Foodandbeveragesadvertise';

// Document Viewer Modal Component
const DocumentViewerModal = ({ isOpen, onClose, title, content }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: window.innerWidth < 768 ? '15px' : '20px',
        maxWidth: window.innerWidth < 768 ? '95%' : '80%',
        width: '100%',
        maxHeight: window.innerWidth < 768 ? '80vh' : '85vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
        position: 'relative'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '15px',
          paddingBottom: '10px',
          borderBottom: '2px solid #A055B0',
          flexWrap: 'wrap',
          gap: '10px'
        }}>
          <h3 style={{
            margin: 0,
            color: '#A055B0',
            fontSize: window.innerWidth < 768 ? '18px' : '22px',
            fontWeight: 'bold',
            flex: 1
          }}>
            {title}
          </h3>
          
          <button 
            onClick={onClose}
            aria-label="Close document viewer"
            style={{
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              padding: window.innerWidth < 768 ? '8px 12px' : '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: window.innerWidth < 768 ? '12px' : '14px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#d32f2f';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#f44336';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <FaTimes aria-hidden="true" /> Close
          </button>
        </div>

        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '15px',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          border: '1px solid #ddd',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#666'
        }}>
          <div style={{ textAlign: 'center' }}>
            <FaBook aria-hidden="true" style={{ fontSize: '48px', color: '#A055B0', marginBottom: '15px' }} />
            <h4>Document Content Removed</h4>
            <p>This document content has been removed as per requirements.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Success Modal Component
const SuccessModal = ({ isOpen, onClose, message, title = "Success!" }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: window.innerWidth < 768 ? '20px' : '30px',
        maxWidth: window.innerWidth < 768 ? '90%' : '500px',
        width: '100%',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
        position: 'relative'
      }}>
        <button 
          onClick={onClose}
          aria-label="Close success modal"
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            color: '#666',
            cursor: 'pointer',
            width: '30px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f5f5f5';
            e.currentTarget.style.color = '#333';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#666';
          }}
        >
          <FaTimes aria-hidden="true" />
        </button>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '20px'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#4CAF50',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: 'scaleIn 0.5s ease-out'
          }}>
            <FaCheckCircle aria-hidden="true" style={{ color: 'white', fontSize: '40px' }} />
          </div>
        </div>

        <h3 style={{
          textAlign: 'center',
          color: '#4CAF50',
          margin: '0 0 15px 0',
          fontSize: window.innerWidth < 768 ? '22px' : '24px',
          fontWeight: 'bold'
        }}>
          {title}
        </h3>

        <div style={{
          textAlign: 'center',
          color: '#555',
          fontSize: window.innerWidth < 768 ? '16px' : '18px',
          lineHeight: '1.5',
          marginBottom: '25px',
          padding: '0 10px'
        }}>
          {message}
        </div>

        <div style={{ textAlign: 'center' }}>
          <button 
            onClick={onClose}
            aria-label="Close success message"
            style={{
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              padding: window.innerWidth < 768 ? '12px 30px' : '14px 40px',
              borderRadius: '50px',
              cursor: 'pointer',
              fontSize: window.innerWidth < 768 ? '16px' : '18px',
              fontWeight: 'bold',
              minWidth: '150px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#388E3C';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#4CAF50';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.3)';
            }}
          >
            OK, Got it!
          </button>
        </div>
      </div>

      <style>{`
        @keyframes scaleIn {
          from {
            transform: scale(0);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

// Custom Terms Component
const CustomTerms = ({ onNext, onBack, autoAgree = false }) => {
  const [agreed, setAgreed] = useState(false);

  // Auto-agree when component mounts if autoAgree prop is true
  useEffect(() => {
    if (autoAgree) {
      setAgreed(true);
    }
  }, [autoAgree]);

  const policySections = [
    {
      id: "reservation",
      title: "Reservation Policy",
      icon: <FaCalendarCheck aria-hidden="true" />,
      color: "#4CAF50",
      points: [
        "Customers are encouraged to make reservations in advance.",
        "Reservations are held for 15 minutes beyond the scheduled time.",
        "Large group reservations (8+ people) require 24-hour notice for cancellations.",
        "Special occasion reservations may require a deposit."
      ]
    },
    {
      id: "cancellation",
      title: "Cancellation Policy",
      icon: <FaTimes aria-hidden="true" />,
      color: "#FF9800",
      points: [
        "Please cancel or modify your reservation at least 2 hours before your scheduled time.",
        "Late cancellations may incur a fee of 50% of the estimated bill.",
        "No-shows will be charged 100% of the reservation deposit.",
        "Special event cancellations require 48-hour notice."
      ]
    },
    {
      id: "payment",
      title: "Payment Terms",
      icon: <FaShoppingCart aria-hidden="true" />,
      color: "#2196F3",
      points: [
        "We accept cash, major credit/debit cards, and online payments.",
        "All prices are inclusive of applicable taxes unless mentioned otherwise.",
        "Service charge of 10% may apply for parties of 6 or more.",
        "Split bills are subject to individual card minimums."
      ]
    },
    // {
    //   id: "food-beverage",
    //   title: "Food & Beverage Policies",
    //   icon: <FaUtensils aria-hidden="true" />,
    //   color: "#9C27B0",
    //   points: [
    //     "Outside food and beverages are not permitted.",
    //     "Special dietary requirements must be communicated in advance.",
    //     "Food allergies must be declared at the time of ordering.",
    //     "Unfinished food may be packaged for takeaway upon request."
    //   ]
    // }
  ];

  const handleNext = () => {
    if (!agreed) {
      alert("Please read and agree to the Terms & Conditions before proceeding.");
      return;
    }

    // Mark terms as compliant
    const data = {
      agreed: true,
      agreedDate: new Date().toISOString(),
      vendorId: localStorage.getItem("vendorId") || "",
      vendorName: localStorage.getItem("vendorName") || "",
      termsVersion: "v1.5",
      submissionId: `TNC-${Date.now()}`,
      vendorEmail: localStorage.getItem("vendorEmail") || "vendor@example.com"
    };

    console.log("Terms & Conditions agreed:", data);

    // Call onNext callback if provided
    if (onNext) {
      onNext(data);
    }
  };

  return (
    <div 
      role="document"
      aria-label="Terms and Conditions Agreement"
      title="Terms and Conditions Agreement Document"
      style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: window.innerWidth < 768 ? '10px' : '20px'
      }}
    >
      {/* Header */}
      <header style={{
        textAlign: 'center',
        marginBottom: '50px'
      }}>
        <h1 style={{
          margin: '0 0 15px 0',
          fontSize: window.innerWidth < 768 ? '26px' : '34px',
          fontWeight: 'bold',
          color: '#333',
          backgroundImage: 'linear-gradient(135deg, #A055B0 0%, #8a4b9b 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textSizeAdjust: '100%',
          WebkitTextSizeAdjust: '100%'
        }}>
          Terms & Conditions Agreement
        </h1>
        
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '15px',
          flexWrap: 'wrap',
          fontSize: '14px',
          color: '#666',
          textAlign: 'match-parent',
          textAlign: '-webkit-match-parent'
        }}>
          {/* <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}>
            <FaGavel aria-hidden="true" style={{ color: '#A055B0' }} />
            Version 1.5
          </span>
          <span aria-hidden="true" style={{ color: '#999' }}>•</span>
          <span>
            Last Updated: March 15, 2024
          </span> */}
        </div>
      </header>

      {/* Policy Sections */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '60px',
        marginBottom: '50px'
      }}>
        {policySections.map((section) => (
          <section 
            key={section.id}
            id={section.id}
            aria-labelledby={`${section.id}-title`}
            style={{
              position: 'relative',
              paddingLeft: window.innerWidth < 768 ? '20px' : '45px'
            }}
          >
            {/* Vertical Line */}
            <div 
              role="presentation"
              aria-hidden="true"
              title=""
              style={{
                position: 'absolute',
                left: window.innerWidth < 768 ? '8px' : '22px',
                top: '40px',
                bottom: '-40px',
                width: '2px',
                backgroundColor: section.color + '30',
                zIndex: 0
              }}
            />
            
            {/* Icon Circle */}
            <div 
              role="presentation"
              aria-hidden="true"
              title=""
              style={{
                position: 'absolute',
                left: window.innerWidth < 768 ? '0' : '12px',
                top: '0',
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                backgroundColor: section.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                zIndex: 1,
                fontSize: '14px'
              }}
            >
              {section.icon}
            </div>
            
            {/* Content */}
            <div style={{ position: 'relative', zIndex: 1 }}>
              <h2 
                id={`${section.id}-title`}
                style={{
                  margin: '0 0 25px 0',
                  fontSize: window.innerWidth < 768 ? '20px' : '24px',
                  color: section.color,
                  fontWeight: 'bold',
                  paddingBottom: '12px',
                  borderBottom: `2px solid ${section.color}20`
                }}
              >
                {section.title}
              </h2>
              
              <ul 
                aria-label={`Points for ${section.title}`}
                style={{
                  listStyleType: 'none',
                  padding: 0,
                  margin: 0
                }}
              >
                {section.points.map((point, index) => (
                  <li 
                    key={index}
                    style={{
                      marginBottom: '22px',
                      position: 'relative',
                      paddingLeft: '35px',
                      fontSize: window.innerWidth < 768 ? '15px' : '16px',
                      lineHeight: '1.7',
                      color: '#444'
                    }}
                  >
                    <div 
                      role="presentation"
                      aria-hidden="true"
                      title=""
                      style={{
                        position: 'absolute',
                        left: '0',
                        top: '8px',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: section.color + '20',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        color: section.color,
                        fontWeight: 'bold'
                      }}
                    >
                      {index + 1}
                    </div>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </section>
        ))}
      </div>

      {/* Important Notice */}
      <section 
        aria-label="Important Notice"
        style={{
          marginBottom: '10px',
          padding: '10px',
          borderRadius: '8px',
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          position: 'relative'
        }}
      >
        <div 
          role="presentation"
          aria-hidden="true"
          title=""
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            fontSize: '30px',
            color: '#A055B0',
            opacity: 0.1
          }}
        >
          <FaExclamationTriangle aria-hidden="true" />
        </div>
        
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px',
          marginBottom: '12px'
        }}>
          <FaExclamationTriangle aria-hidden="true" style={{
            color: '#A055B0',
            fontSize: '18px',
            flexShrink: 0,
            marginTop: '3px'
          }} />
          <h3 style={{
            margin: 0,
            color: '#333',
            fontSize: '17px',
            fontWeight: 'bold'
          }}>
            Important Notice
          </h3>
        </div>
        
        <p style={{
          margin: 0,
          fontSize: '15px',
          color: '#555',
          lineHeight: '1.7',
          paddingLeft: '30px'
        }}>
          By agreeing to these terms, you confirm you've read and understood our policies. Terms may change with notice. We reserve the right to refuse service at any time.
        </p>
      </section>

      {/* Agreement Section */}
      <section 
        aria-label="Agreement Section"
        style={{
          marginBottom: '10px',
          padding: '25px 0',
          borderTop: '2px solid #f0f0f0',
          borderBottom: '2px solid #f0f0f0'
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '20px',
          flexDirection: window.innerWidth < 768 ? 'column' : 'row'
        }}>
          <div style={{
            flexShrink: 0,
            position: 'relative'
          }}>
            <input 
              type="checkbox" 
              id="termsAgreement"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              aria-labelledby="termsAgreementLabel"
              style={{
                position: 'absolute',
                opacity: 0,
                width: 0,
                height: 0
              }}
            />
            <label 
              htmlFor="termsAgreement"
              title="Agree to Terms and Conditions checkbox"
              style={{
                display: 'block',
                width: '36px',
                height: '36px',
                borderRadius: '6px',
                border: `2px solid ${agreed ? '#4CAF50' : '#ddd'}`,
                background: agreed ? '#4CAF50' : 'white',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                color: 'white',
                fontWeight: 'bold'
              }}
            >
              {agreed && <FaCheckCircle aria-hidden="true" />}
            </label>
          </div>
          
          <div style={{ flex: 1 }}>
            <label 
              id="termsAgreementLabel"
              htmlFor="termsAgreement"
              style={{
                display: 'block',
                fontSize: window.innerWidth < 768 ? '18px' : '20px',
                fontWeight: 'bold',
                color: agreed ? '#2e7d32' : '#333',
                cursor: 'pointer',
                lineHeight: '1.5',
                marginBottom: '8px'
            }}>
              {agreed ? '✓ I agree to the Terms & Conditions' : 'I agree to the Terms & Conditions'}
            </label>
            <p style={{
              margin: 0,
              fontSize: '15px',
              color: agreed ? '#4CAF50' : '#666',
              lineHeight: '1.6'
            }}>
              {agreed 
                ? 'You have read and agreed to all policies stated above.'
                : 'You must read and agree to the Terms and Conditions before proceeding to Vendor Guidelines.'
              }
            </p>
            {autoAgree && agreed && (
              <div style={{
                marginTop: '10px',
                padding: '8px 12px',
                backgroundColor: '#e8f5e9',
                borderRadius: '6px',
                fontSize: '14px',
                color: '#2e7d32',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <FaCheckCircle aria-hidden="true" />
                Auto-agreed for convenience
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Navigation Buttons */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '40px',
        paddingTop: '20px',
        borderTop: '1px solid #e0e0e0',
        flexDirection: window.innerWidth < 768 ? 'column' : 'row',
        gap: window.innerWidth < 768 ? '15px' : '0'
      }}>
        <button 
          onClick={onBack}
          aria-label="Go back to Privacy Policy"
          style={{
            padding: window.innerWidth < 768 ? '14px 30px' : '16px 40px',
            borderRadius: '8px',
            border: '2px solid #A055B0',
            background: 'white',
            color: '#A055B0',
            cursor: 'pointer',
            fontSize: window.innerWidth < 768 ? '14px' : '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            transition: 'all 0.3s ease',
            minWidth: '180px',
            order: window.innerWidth < 768 ? 2 : 1
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f5f0f7';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          ← Back to Privacy Policy
        </button>

        <button 
          onClick={handleNext}
          disabled={!agreed}
          aria-label={agreed ? "Proceed to Vendor Guidelines" : "Please agree to terms first"}
          title={agreed ? "Navigate to Vendor Guidelines" : "You must agree to the terms first"}
          style={{
            padding: window.innerWidth < 768 ? '14px 30px' : '16px 40px',
            borderRadius: '8px',
            border: 'none',
            background: agreed ? 'linear-gradient(135deg, #A055B0 0%, #8a4b9b 100%)' : '#e0e0e0',
            color: agreed ? 'white' : '#999',
            cursor: agreed ? 'pointer' : 'not-allowed',
            fontSize: window.innerWidth < 768 ? '14px' : '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            transition: agreed ? 'all 0.3s ease' : 'none',
            boxShadow: agreed ? '0 4px 12px rgba(160, 85, 176, 0.2)' : 'none',
            minWidth: '220px',
            order: 1
          }}
          onMouseEnter={(e) => {
            if (agreed) {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(160, 85, 176, 0.3)';
            }
          }}
          onMouseLeave={(e) => {
            if (agreed) {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(160, 85, 176, 0.2)';
            }
          }}
        >
          {agreed ? (
            <>
              Next: Vendor Guidelines
              <FaArrowRight aria-hidden="true" />
            </>
          ) : (
            'Next: Vendor Guidelines'
          )}
        </button>
      </div>
    </div>
  );
};

const FoodLeagelandcompliance = () => {
    const [activeTab, setActiveTab] = useState("Privacy Policy");
    const { showLoader, hideLoader } = useLoader();
    const [showDocumentViewer, setShowDocumentViewer] = useState(false);
    const [currentDocument, setCurrentDocument] = useState({ title: '', content: '', type: '' });
    const [termsTabJustOpened, setTermsTabJustOpened] = useState(false);

    const [complianceData, setComplianceData] = useState({
        privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15" },
        termsConditions: { status: "pending", lastUpdated: "2024-02-28" },
        vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20" },
        gdpr: { status: "compliant", lastUpdated: "2024-03-10" },
        dataRetention: { status: "compliant", lastUpdated: "2024-03-05" }
    });

    const [vendorId, setVendorId] = useState(null);

    // Clean up: Remove unused document contents or actually use them
    const documentContents = {
        privacyPolicy: {
            title: "Privacy Policy - FoodLeague Platform",
            content: (
                <div style={{ lineHeight: '1.6', textAlign: 'center', padding: '50px 20px' }}>
                    <FaBook aria-hidden="true" style={{ fontSize: '64px', color: '#A055B0', marginBottom: '20px' }} />
                    <h3>Privacy Policy Content</h3>
                    <p>This document content has been removed as per requirements.</p>
                </div>
            )
        },
        termsConditions: {
            title: "Terms & Conditions - FoodLeague Platform",
            content: (
                <div style={{ lineHeight: '1.6', textAlign: 'center', padding: '50px 20px' }}>
                    <FaBook aria-hidden="true" style={{ fontSize: '64px', color: '#A055B0', marginBottom: '20px' }} />
                    <h3>Terms & Conditions Content</h3>
                    <p>This document content has been removed as per requirements.</p>
                </div>
            )
        },
        vendorGuidelines: {
            title: "Vendor Guidelines - FoodLeague Platform",
            content: (
                <div style={{ lineHeight: '1.6', textAlign: 'center', padding: '50px 20px' }}>
                    <FaBook aria-hidden="true" style={{ fontSize: '64px', color: '#A055B0', marginBottom: '20px' }} />
                    <h3>Vendor Guidelines Content</h3>
                    <p>This document content has been removed as per requirements.</p>
                </div>
            )
        }
    };

    // Clean up: Remove unused functions or actually use them
    const handleViewDocument = useCallback((type) => {
        setCurrentDocument({
            title: documentContents[type].title,
            content: documentContents[type].content,
            type: type
        });
        setShowDocumentViewer(true);
    }, [documentContents]);

    const handleCloseDocumentViewer = useCallback(() => {
        setShowDocumentViewer(false);
    }, []);

    // Responsive container height function
    const getContainerHeight = useCallback(() => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      if (height <= 600) {
        return width < 768 ? '250px' : width < 992 ? '300px' : '350px';
      }

      if (width < 576) return '50vh';
      if (width < 768) return '55vh';
      if (width < 992) return '60vh';
      if (width < 1200) return '65vh';
      return '70vh';
    }, []);

    const containerHeight = getContainerHeight();

    // Function to get tab display text - Always show full text
    const getTabDisplayText = useCallback((label) => {
      // Always show full text
      return label;
    }, []);

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) {
            setVendorId(storedVendorId);
        }
    }, []);

    // Fetch compliance data with CORS fix
    const fetchComplianceData = useCallback(async () => {
        try {
            showLoader();
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!token || !vendorId) {
                console.warn("Missing token or vendorId");
                return;
            }

            // For development, use mock data instead of actual API call
            // Remove or comment this in production when CORS is fixed
            const mockData = {
                privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15", version: "v2.1" },
                termsConditions: { status: "pending", lastUpdated: "2024-02-28", version: "v1.5" },
                vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20", version: "v3.0" },
                gdpr: { status: "compliant", lastUpdated: "2024-03-10", version: "v1.2" },
                dataRetention: { status: "compliant", lastUpdated: "2024-03-05", version: "v1.0" }
            };
            
            setComplianceData(mockData);
            
        } catch (error) {
            console.error("Failed to fetch compliance data:", error);
            // Use mock data as fallback
            setComplianceData({
                privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15", version: "v2.1" },
                termsConditions: { status: "pending", lastUpdated: "2024-02-28", version: "v1.5" },
                vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20", version: "v3.0" },
                gdpr: { status: "compliant", lastUpdated: "2024-03-10", version: "v1.2" },
                dataRetention: { status: "compliant", lastUpdated: "2024-03-05", version: "v1.0" }
            });
        } finally {
            hideLoader();
        }
    }, [showLoader, hideLoader]);

    useEffect(() => {
        fetchComplianceData();
    }, [fetchComplianceData]);

    const getStatusIcon = useCallback((status) => {
        switch(status) {
            case 'compliant': return <FaCheckCircle aria-hidden="true" style={{ color: '#4CAF50', marginRight: '5px' }} />;
            case 'pending': return <FaClock aria-hidden="true" style={{ color: '#FFC107', marginRight: '5px' }} />;
            case 'non-compliant': return <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '5px' }} />;
            default: return null;
        }
    }, []);

    const getStatusColor = useCallback((status) => {
        switch(status) {
            case 'compliant': return '#4CAF50';
            case 'pending': return '#FFC107';
            case 'non-compliant': return '#f44336';
            default: return '#757575';
        }
    }, []);

    // Tab content definitions
    const tabContent = {
        "Privacy Policy": (
            <div style={{ padding: window.innerWidth < 768 ? '0px' : '10px 10px' }}>
                <div style={cardStyle}>
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        flexDirection: window.innerWidth < 576 ? 'column' : 'row',
                        gap: window.innerWidth < 576 ? '10px' : '0'
                    }}>
                        {/* Content removed as per requirements */}
                    </div>
                    
                    <div style={{ marginTop: '10px' }}>
                        <div style={{ 
                            borderRadius: '12px',
                            marginBottom: '15px',
                        }}>
                            <h5 style={{ 
                                fontSize: window.innerWidth < 768 ? '18px' : '22px',
                                color: '#2e7d32',
                                marginBottom: '15px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <FaShieldAlt aria-hidden="true" style={{ marginRight: '12px' }} />
                                Food & Beverages Vendor Data Protection
                            </h5>
                            
                            <div style={{ 
                                borderRadius: '10px',
                                marginBottom: '15px',
                            }}>
                                <h6 style={{ 
                                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                    color: '#2e7d32',
                                    marginBottom: '15px'
                                }}>
                                    🍽️ Food Safety & Ingredient Data Collection
                                </h6>
                                <ul style={{ paddingLeft: '20px', fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6' }}>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Temperature Monitoring:</strong> We collect and secure temperature logs for refrigeration and cooking equipment to ensure food safety compliance. All temperature data is encrypted and stored for regulatory audits.
                                    </li>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Ingredient Sourcing:</strong> Detailed information about ingredient suppliers, batch numbers, and expiration dates are securely stored with end-to-end encryption to maintain supply chain transparency.
                                    </li>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Preparation Protocols:</strong> Food preparation methods, cooking times, and handling procedures are documented with strict access controls to protect proprietary recipes and ensure consistency.
                                    </li>
                                </ul>
                            </div>

                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '10px',
                                marginBottom: '15px',
                            }}>
                                <h6 style={{ 
                                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                    color: '#2e7d32',
                                    marginBottom: '15px'
                                }}>
                                    🚫 Allergy & Dietary Restriction Management
                                </h6>
                                <ul style={{ paddingLeft: '20px', fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6' }}>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Customer Allergy Profiles:</strong> We implement zero-knowledge encryption for sensitive allergy information. Data is anonymized and only accessible to authorized kitchen staff during order preparation.
                                    </li>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Dietary Preferences:</strong> Vegan, vegetarian, gluten-free, and other dietary preferences are stored with explicit customer consent and can be deleted upon request at any time.
                                    </li>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Cross-Contamination Prevention:</strong> Our system tracks and logs allergen-free preparation zones with real-time monitoring to ensure customer safety.
                                    </li>
                                </ul>
                            </div>

                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '10px',
                                marginBottom: '15px',
                            }}>
                                <h6 style={{ 
                                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                    color: '#2e7d32',
                                    marginBottom: '15px'
                                }}>
                                    📊 Customer Experience & Personalization
                                </h6>
                                <ul style={{ paddingLeft: '20px', fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6' }}>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Menu Preferences:</strong> Customer food preferences, favorite dishes, and order history are analyzed with machine learning algorithms to provide personalized recommendations while maintaining data anonymity.
                                    </li>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Feedback Analysis:</strong> Customer reviews and feedback are processed to improve service quality. All feedback is anonymized after 30 days unless explicit consent is given for longer retention.
                                    </li>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Loyalty Programs:</strong> Points, rewards, and special offers data is protected with bank-level security protocols and regular security audits.
                                    </li>
                                </ul>
                            </div>

                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '10px',
                            }}>
                                <h6 style={{ 
                                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                    color: '#2e7d32',
                                    marginBottom: '15px'
                                }}>
                                    💳 Payment & Transaction Security
                                </h6>
                                <ul style={{ paddingLeft: '20px', fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6' }}>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>PCI-DSS Compliance:</strong> All payment information is tokenized and never stored on our servers. We partner with PCI-DSS Level 1 certified payment processors for maximum security.
                                    </li>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Transaction Analytics:</strong> Purchase patterns and transaction data are analyzed in aggregate form only, with individual customer data never shared with third parties.
                                    </li>
                                    <li style={{ marginBottom: '10px' }}>
                                        <strong>Fraud Prevention:</strong> Real-time fraud detection systems monitor transactions while maintaining customer privacy through advanced encryption techniques.
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '12px',
                            marginBottom: '15px',
                        }}>
                            <h5 style={{ 
                                fontSize: window.innerWidth < 768 ? '18px' : '22px',
                                color: '#1b5e20',
                                textAlign: 'center',
                                marginBottom: '15px'
                            }}>
                                🛡️ Enhanced Security Measures for Food Businesses
                            </h5>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
                                gap: '10px',
                                fontSize: window.innerWidth < 768 ? '14px' : '15px'
                            }}>
                                <div style={{ padding: '15px', borderRadius: '8px', }}>
                                    <strong style={{ color: '#2e7d32' }}>🧪 Food Safety Data Encryption</strong>
                                    <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                                        All HACCP logs, temperature readings, and safety checks are encrypted using AES-256 encryption with automated backup to secure cloud storage.
                                    </p>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '8px',  }}>
                                    <strong style={{ color: '#2e7d32' }}>📋 Regulatory Compliance Tracking</strong>
                                    <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                                        Automated tracking of FSSAI regulations, health department requirements, and food safety standards with real-time compliance alerts.
                                    </p>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '8px', }}>
                                    <strong style={{ color: '#2e7d32' }}>👥 Staff Access Controls</strong>
                                    <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                                        Role-based access with biometric authentication for sensitive areas like recipe databases and customer allergy information.
                                    </p>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '8px', }}>
                                    <strong style={{ color: '#2e7d32' }}>🔄 Supply Chain Transparency</strong>
                                    <p style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
                                        Blockchain-based tracking for ingredient sourcing with immutable records for quality assurance and recall management.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '10px',
                        }}>
                            <h5 style={{ 
                                fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                color: '#e65100',
                                marginBottom: '15px'
                            }}>
                                📜 Data Retention & Customer Rights
                            </h5>
                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '8px',
                                marginBottom: '15px',
                            }}>
                                <strong>Data Retention Periods:</strong>
                                <ul style={{ paddingLeft: '20px', marginTop: '10px', fontSize: '14px' }}>
                                    <li>Order history: 7 years for tax purposes</li>
                                    <li>Customer preferences: 2 years of active use</li>
                                    <li>Feedback and reviews: 3 years</li>
                                    <li>Allergy information: Deleted upon customer request or after 1 year of inactivity</li>
                                    <li>Payment information: Not stored - processed via tokenization</li>
                                </ul>
                            </div>
                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '8px',
                            }}>
                                <strong>Customer Rights:</strong>
                                <ul style={{ paddingLeft: '20px', marginTop: '10px', fontSize: '14px' }}>
                                    <li>Right to access personal data</li>
                                    <li>Right to correct inaccurate information</li>
                                    <li>Right to delete personal data (with exceptions for legal requirements)</li>
                                    <li>Right to data portability</li>
                                    <li>Right to object to processing</li>
                                </ul>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '10px',
                            marginTop: '10px',
                            textAlign: 'center'
                        }}>
                            <h5 style={{ 
                                fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                color: '#1565c0',
                                marginBottom: '10px'
                            }}>
                                🔐 Our Privacy Commitment to Food & Beverage Vendors
                            </h5>
                            <p style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px', lineHeight: '1.6', color: '#333' }}>
                                We understand the unique privacy challenges faced by food and beverage businesses. Our platform is designed with industry-specific security measures, 
                                ensuring that your customer data, proprietary recipes, and business operations remain protected while delivering exceptional dining experiences.
                            </p>
                            <div style={{ 
                                marginTop: '10px', 
                                padding: '10px', 
                                borderRadius: '8px',
                                display: 'inline-block',
                            }}>
                                <strong style={{ color: '#1565c0' }}>24/7 Privacy Support:</strong> Dedicated team available for food safety data emergencies
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),

        "Terms & Conditions": (
            <div style={{ padding: window.innerWidth < 768 ? '10px' : '10px 10px' }}>
                <div style={cardStyle}>
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        flexDirection: window.innerWidth < 576 ? 'column' : 'row',
                        gap: window.innerWidth < 576 ? '10px' : '0'
                    }}>
                        <div style={{ width: window.innerWidth < 576 ? '100%' : 'auto' }}>
                            {/* <h4 style={{ 
                                margin: '0 0 10px 0', 
                                color: '#A055B0',
                                fontSize: window.innerWidth < 768 ? '18px' : '20px',
                                textAlign: window.innerWidth < 576 ? 'center' : 'left'
                            }}>
                                Terms & Conditions 
                            </h4> */}
                        </div>
                    </div>

                    <div style={{ marginTop: '20px', padding: '15px', borderRadius: '8px' }}>
                        <CustomTerms 
                            onNext={(data) => {
                                console.log("Terms & Conditions submitted:", data);
                                setComplianceData(prev => ({
                                    ...prev,
                                    termsConditions: { 
                                        ...prev.termsConditions, 
                                        status: "compliant",
                                        lastUpdated: new Date().toISOString().split('T')[0],
                                        agreed: true,
                                        agreedDate: new Date().toISOString(),
                                        submissionId: data.submissionId
                                    }
                                }));
                                // Navigate to Vendor Guidelines tab
                                setActiveTab("Vendor Guidelines");
                            }}
                            onBack={() => {
                                setActiveTab("Privacy Policy");
                            }}
                            autoAgree={termsTabJustOpened}
                        />
                    </div>
                </div>
            </div>
        ),

        "Vendor Guidelines": (
            <div style={{ padding: window.innerWidth < 768 ? '10px' : '5px 10px' ,marginTop:"5px"}}>
                <div style={cardStyle}>
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        flexDirection: window.innerWidth < 576 ? 'column' : 'row',
                        gap: window.innerWidth < 576 ? '10px' : '0'
                    }}>
                        {/* Content removed as per requirements */}
                    </div>
                    
                    <div style={{ marginTop: '20px' }}>
                        <h5 style={{ 
                            fontSize: window.innerWidth < 768 ? '18px' : '22px', 
                            color: '#2e7d32',
                            textAlign: 'center',
                            marginBottom: '10px',
                            paddingBottom: '15px',
                            borderBottom: '3px solid #2e7d32'
                        }}>
                            <FaUtensils aria-hidden="true" style={{ marginRight: '15px' }} />
                            Food & Beverages Vendor Excellence Standards
                        </h5>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '12px',
                            marginBottom: '10px',
                        }}>
                            <h6 style={{ 
                                fontSize: window.innerWidth < 768 ? '18px' : '20px',
                                color: '#e65100',
                                marginBottom: '10px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                🍳 Food Safety & Hygiene Standards
                            </h6>
                            
                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '10px',
                                marginBottom: '10px',
                            }}>
                                <h6 style={{ 
                                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                    color: '#d84315',
                                    marginBottom: '15px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <FaShieldAlt aria-hidden="true" style={{ marginRight: '10px' }} />
                                    HACCP Compliance Requirements
                                </h6>
                                <ul style={{ paddingLeft: '20px', marginBottom: '15px', fontSize: '14px' }}>
                                    <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
                                        <strong>Temperature Control:</strong> All refrigeration units must maintain temperatures below 5°C (41°F). Freezers must be at -18°C (0°F) or lower. Temperature logs must be maintained every 4 hours.
                                    </li>
                                    <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
                                        <strong>Food Storage:</strong> Raw and cooked foods must be stored separately. All food items must be labeled with preparation date and use-by date.
                                    </li>
                                    <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
                                        <strong>Cross-Contamination Prevention:</strong> Color-coded cutting boards and utensils for different food types. Separate preparation areas for allergen-free meals.
                                    </li>
                                    <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
                                        <strong>Cooking Temperatures:</strong> Poultry: 74°C (165°F), Ground meats: 71°C (160°F), Pork: 63°C (145°F), Seafood: 63°C (145°F).
                                    </li>
                                </ul>
                            </div>

                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '10px',
                                marginBottom: '10px',
                            }}>
                                <h6 style={{ 
                                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                    color: '#d84315',
                                    marginBottom: '15px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    👨‍🍳 Staff Hygiene & Training
                                </h6>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
                                    gap: '15px',
                                    marginBottom: '15px'
                                }}>
                                    <div style={{ padding: '15px', borderRadius: '8px',  }}>
                                        <strong style={{ color: '#e65100' }}>Personal Hygiene</strong>
                                        <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                            <li>Hand washing every 30 minutes</li>
                                            <li>Clean uniforms daily</li>
                                            <li>Hair restraints mandatory</li>
                                            <li>No jewelry in food areas</li>
                                        </ul>
                                    </div>
                                    <div style={{ padding: '15px', borderRadius: '8px',  }}>
                                        <strong style={{ color: '#e65100' }}>Health Requirements</strong>
                                        <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                            <li>Annual medical examinations</li>
                                            <li>No working with infectious diseases</li>
                                            <li>Regular health declaration</li>
                                            <li>Vaccination records maintained</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '12px',
                            marginBottom: '10px',
                        }}>
                            <h6 style={{ 
                                fontSize: window.innerWidth < 768 ? '18px' : '20px',
                                color: '#2e7d32',
                                marginBottom: '20px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                🥘 Quality & Consistency Standards
                            </h6>
                            
                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '10px',
                                marginBottom: '10px',
                            }}>
                                <h6 style={{ 
                                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                    color: '#388e3c',
                                    marginBottom: '10px'
                                }}>
                                    Ingredient Quality Control
                                </h6>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(3, 1fr)',
                                    gap: '15px',
                                    marginBottom: '10px'
                                }}>
                                    <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
                                        <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>100%</div>
                                        <div style={{ fontSize: '12px', color: '#666' }}>Fresh Ingredients Only</div>
                                    </div>
                                    <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
                                        <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>24h</div>
                                        <div style={{ fontSize: '12px', color: '#666' }}>Delivery-to-Use Window</div>
                                    </div>
                                    <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
                                        <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>5⭐</div>
                                        <div style={{ fontSize: '12px', color: '#666' }}>Supplier Rating Minimum</div>
                                    </div>
                                </div>
                                
                                <div style={{ 
                                    padding: '10px', 
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                }}>
                                    <strong>Ingredient Specifications:</strong>
                                    <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                        <li>Vegetables: Washed and sanitized within 2 hours of receipt</li>
                                        <li>Meat & Poultry: From approved suppliers with traceability certificates</li>
                                        <li>Seafood: Fresh only, delivered daily with temperature certification</li>
                                        <li>Spices & Herbs: Organic preferred, stored in airtight containers</li>
                                    </ul>
                                </div>
                            </div>

                            <div style={{ 
                                padding: '00px', 
                                borderRadius: '10px',
                            }}>
                                <h6 style={{ 
                                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                    color: '#388e3c',
                                    marginBottom: '15px'
                                }}>
                                    Portion Control & Presentation
                                </h6>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
                                    gap: '15px'
                                }}>
                                    <div style={{ padding: '10px', borderRadius: '8px',  }}>
                                        <strong style={{ color: '#388e3c' }}>Standardized Portions</strong>
                                        <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
                                            All dishes must follow standardized portion sizes (±5% variance). Regular calibration of measuring equipment required.
                                        </p>
                                    </div>
                                    <div style={{ padding: '10px', borderRadius: '8px',  }}>
                                        <strong style={{ color: '#388e3c' }}>Presentation Standards</strong>
                                        <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
                                            Consistent plating, garnish placement, and service ware. Daily quality control checks with photo documentation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '12px',
                            marginBottom: '5px',
                        }}>
                            <h6 style={{ 
                                fontSize: window.innerWidth < 768 ? '18px' : '20px',
                                color: '#1565c0',
                                marginBottom: '5px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                ⏱️ Service & Operational Excellence
                            </h6>
                            
                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '10px',
                                marginBottom: '5px',
                            }}>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(3, 1fr)',
                                    gap: '15px',
                                    marginBottom: '10px'
                                }}>
                                    <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
                                        <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>15</div>
                                        <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Order Acknowledgment</div>
                                    </div>
                                    <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
                                        <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>30</div>
                                        <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Preparation Time Max</div>
                                    </div>
                                    <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px', }}>
                                        <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>99%</div>
                                        <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Order Accuracy Required</div>
                                    </div>
                                </div>
                                
                                <div style={{ 
                                    padding: '10px', 
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                }}>
                                    <strong>Customer Service Protocol:</strong>
                                    <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                        <li>Phone answered within 3 rings during business hours</li>
                                        <li>Email responses within 2 hours during business hours</li>
                                        <li>Online order confirmation within 10 minutes</li>
                                        <li>Special requests acknowledged and documented</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '12px',
                            marginBottom: '5px',
                        }}>
                            <h6 style={{ 
                                fontSize: window.innerWidth < 768 ? '18px' : '20px',
                                color: '#7b1fa2',
                                marginBottom: '5px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                📋 Compliance & Documentation
                            </h6>
                            
                            <div style={{ 
                                padding: '10px', 
                                borderRadius: '10px',
                            }}>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
                                    gap: '15px'
                                }}>
                                    <div style={{ padding: '10px', borderRadius: '8px',  }}>
                                        <strong style={{ color: '#7b1fa2' }}>Required Licenses</strong>
                                        <ul style={{ paddingLeft: '15px', marginTop: '5px', fontSize: '13px' }}>
                                            <li>FSSAI License (Valid)</li>
                                            <li>Health Trade License</li>
                                            <li>Fire Safety Certificate</li>
                                            <li>GST Registration</li>
                                            <li>Shop & Establishment Act</li>
                                        </ul>
                                    </div>
                                    <div style={{ padding: '10px', borderRadius: '8px', }}>
                                        <strong style={{ color: '#7b1fa2' }}>Mandatory Documentation</strong>
                                        <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                            <li>Daily Temperature Logs</li>
                                            <li>Staff Training Records</li>
                                            <li>Supplier Certificates</li>
                                            <li>Pest Control Reports</li>
                                            <li>Equipment Maintenance Logs</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '12px',
                            marginTop: '10px',
                            textAlign: 'center'
                        }}>
                            <h6 style={{ 
                                fontSize: window.innerWidth < 768 ? '18px' : '22px',
                                color: '#ff6f00',
                                marginBottom: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <FaStar aria-hidden="true" style={{ marginRight: '15px' }} />
                                Performance Metrics & Reviews
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(4, 1fr)',
                                gap: '15px',
                                marginBottom: '10px'
                            }}>
                                <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px', }}>
                                    <div style={{ fontSize: '28px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>4.5⭐</div>
                                    <div style={{ fontSize: '14px', color: '#666' }}>Minimum Customer Rating</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px', }}>
                                    <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>95%</div>
                                    <div style={{ fontSize: '14px', color: '#666' }}>Order Accuracy Required</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px', }}>
                                    <div style={{ fontSize: '28px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>30min</div>
                                    <div style={{ fontSize: '14px', color: '#666' }}>Max Preparation Time</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '10px', borderRadius: '8px',  }}>
                                    <div style={{ fontSize: '28px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>48h</div>
                                    <div style={{ fontSize: '14px', color: '#666' }}>Complaint Resolution Time</div>
                                </div>
                            </div>
                            
                            <div style={{ 
                                marginTop: '10px', 
                                padding: '10px', 
                                borderRadius: '8px',
                                textAlign: 'center',
                            }}>
                                <p style={{ margin: 0, fontSize: window.innerWidth < 768 ? '14px' : '16px', fontWeight: 'bold', color: '#d84315' }}>
                                    ⚠️ Compliance Note: Vendors maintaining below 4.0 rating for 3 consecutive months will undergo mandatory retraining. 
                                    Ratings below 3.5 for 2 months may result in temporary suspension.
                                </p>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '10px', 
                            borderRadius: '12px',
                            marginTop: '5px',
                            textAlign: 'center',
                        }}>
                            <h6 style={{ 
                                fontSize: window.innerWidth < 768 ? '18px' : '20px',
                                color: '#2e7d32',
                                marginBottom: '5px'
                            }}>
                                🎯 Continuous Improvement Program
                            </h6>
                            <p style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px', color: '#333', marginBottom: '10px' }}>
                                Monthly performance reviews with improvement action plans. Quarterly mystery shopping evaluations. 
                                Annual comprehensive audit with certification renewal.
                            </p>
                            <button 
                                style={{
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 10px',
                                    borderRadius: '50px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}
                            >
                                <FaChartLine aria-hidden="true" /> Download Full Guidelines PDF
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        ),

        "Compliance Status": (
            <div style={{ padding: window.innerWidth < 768 ? '10px' : '10px 10px' }}>
                <div style={cardStyle}>
                    <h3 style={{ 
                        color: '#A055B0', 
                        marginBottom: '25px',
                        fontSize: window.innerWidth < 768 ? '20px' : '24px',
                        textAlign: 'center',
                        paddingBottom: '15px',
                        borderBottom: '3px solid #A055B0'
                    }}>
                        <FaChartBar aria-hidden="true" style={{ marginRight: '15px' }} />
                        Food & Beverages Compliance Dashboard
                    </h3>

                    <div style={{ 
                        padding: '25px', 
                        borderRadius: '12px',
                        marginBottom: '30px',
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexDirection: window.innerWidth < 768 ? 'column' : 'row',
                            gap: window.innerWidth < 768 ? '15px' : '0'
                        }}>
                            <div style={{ textAlign: window.innerWidth < 768 ? 'center' : 'left' }}>
                                <h4 style={{ 
                                    fontSize: window.innerWidth < 768 ? '18px' : '22px',
                                    color: '#2e7d32',
                                    marginBottom: '10px'
                                }}>
                                    <FaChartPie aria-hidden="true" style={{ marginRight: '10px' }} />
                                    Overall Food Safety Compliance Score
                                </h4>
                                <p style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px', color: '#555' }}>
                                    Based on comprehensive assessment of food safety, hygiene, quality standards, and operational excellence
                                </p>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                padding: '20px',
                                borderRadius: '10px',
                                minWidth: window.innerWidth < 768 ? '100%' : '200px',
                            }}>
                                <div style={{
                                    fontSize: window.innerWidth < 768 ? '36px' : '48px',
                                    fontWeight: 'bold',
                                    color: '#4CAF50',
                                    marginBottom: '5px'
                                }}>
                                    94%
                                </div>
                                <div style={{ 
                                    fontSize: window.innerWidth < 768 ? '14px' : '16px',
                                    color: '#666'
                                }}>
                                    Excellent Compliance
                                </div>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#4CAF50',
                                    marginTop: '5px',
                                    fontWeight: 'bold'
                                }}>
                                    ▲ 2% from last month
                                </div>
                            </div>
                        </div>
                        
                        <div style={{ marginTop: '25px' }}>
                            <div style={{ marginBottom: '15px' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between',
                                    marginBottom: '5px'
                                }}>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                        <FaUtensils aria-hidden="true" style={{ marginRight: '5px', color: '#4CAF50' }} />
                                        Food Safety Standards
                                    </span>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#4CAF50' }}>96%</span>
                                </div>
                                <div style={{
                                    height: '10px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '5px',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        width: '96%',
                                        height: '100%',
                                        backgroundColor: '#4CAF50',
                                        borderRadius: '5px'
                                    }}></div>
                                </div>
                            </div>
                            
                            <div style={{ marginBottom: '15px' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between',
                                    marginBottom: '5px'
                                }}>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                        <FaShieldAlt aria-hidden="true" style={{ marginRight: '5px', color: '#2196F3' }} />
                                        Hygiene & Sanitation
                                    </span>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#2196F3' }}>92%</span>
                                </div>
                                <div style={{
                                    height: '10px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '5px',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        width: '92%',
                                        height: '100%',
                                        backgroundColor: '#2196F3',
                                        borderRadius: '5px'
                                    }}></div>
                                </div>
                            </div>
                            
                            <div style={{ marginBottom: '15px' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between',
                                    marginBottom: '5px'
                                }}>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                        <FaStar aria-hidden="true" style={{ marginRight: '5px', color: '#FF9800' }} />
                                        Quality Control
                                    </span>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#FF9800' }}>91%</span>
                                </div>
                                <div style={{
                                    height: '10px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '5px',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        width: '91%',
                                        height: '100%',
                                        backgroundColor: '#FF9800',
                                        borderRadius: '5px'
                                    }}></div>
                                </div>
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between',
                                    marginBottom: '5px'
                                }}>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                        <FaClipboardCheck aria-hidden="true" style={{ marginRight: '5px', color: '#9C27B0' }} />
                                        Operational Excellence
                                    </span>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#9C27B0' }}>88%</span>
                                </div>
                                <div style={{
                                    height: '10px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '5px',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        width: '88%',
                                        height: '100%',
                                        backgroundColor: '#9C27B0',
                                        borderRadius: '5px'
                                    }}></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ 
                        marginBottom: '30px',
                        padding: '20px',
                        borderRadius: '10px',
                    }}>
                        <h4 style={{ 
                            fontSize: window.innerWidth < 768 ? '16px' : '18px',
                            color: '#333',
                            marginBottom: '15px',
                            textAlign: 'center'
                        }}>
                            🍽️ Food & Beverages Compliance Categories
                        </h4>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(4, 1fr)',
                            gap: '15px',
                            marginBottom: '20px'
                        }}>
                            {[
                                { 
                                    id: 'food-safety', 
                                    name: 'Food Safety', 
                                    description: 'Temperature control, storage, handling',
                                    icon: <FaShieldAlt aria-hidden="true" />, 
                                    color: '#4CAF50',
                                    score: '96%'
                                },
                                { 
                                    id: 'hygiene', 
                                    name: 'Hygiene Standards', 
                                    description: 'Staff hygiene, sanitation, cleaning',
                                    icon: <FaUsers aria-hidden="true" />, 
                                    color: '#2196F3',
                                    score: '92%'
                                },
                                { 
                                    id: 'quality', 
                                    name: 'Quality Control', 
                                    description: 'Ingredients, preparation, consistency',
                                    icon: <FaStar aria-hidden="true" />, 
                                    color: '#FF9800',
                                    score: '91%'
                                },
                                { 
                                    id: 'operations', 
                                    name: 'Operations', 
                                    description: 'Service, documentation, training',
                                    icon: <FaClipboardCheck aria-hidden="true" />, 
                                    color: '#9C27B0',
                                    score: '88%'
                                }
                            ].map(category => (
                                <div 
                                    key={category.id}
                                    style={{
                                        padding: '20px',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        border: `1px solid ${category.color}`,
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                    }}
                                    onClick={() => alert(`View ${category.name} details`)}
                                >
                                    <div style={{ 
                                        fontSize: '32px', 
                                        color: category.color,
                                        marginBottom: '15px'
                                    }}>
                                        {category.icon}
                                    </div>
                                    <div style={{ 
                                        fontSize: window.innerWidth < 768 ? '16px' : '18px',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        marginBottom: '8px'
                                    }}>
                                        {category.name}
                                    </div>
                                    <div style={{ 
                                        fontSize: window.innerWidth < 768 ? '12px' : '13px',
                                        color: '#666',
                                        marginBottom: '15px',
                                        minHeight: '40px'
                                    }}>
                                        {category.description}
                                    </div>
                                    <div style={{
                                        fontSize: '24px',
                                        fontWeight: 'bold',
                                        color: category.color,
                                        padding: '8px',
                                        borderRadius: '6px'
                                    }}>
                                        {category.score}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: window.innerWidth < 768 ? '1fr' : window.innerWidth < 992 ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', 
                        gap: '20px', 
                        marginBottom: '30px' 
                    }}>
                        {[
                            { 
                                title: "Temperature Control", 
                                status: "compliant", 
                                score: "98%",
                                icon: <FaCheckCircle aria-hidden="true" />,
                                color: "#4CAF50",
                                lastCheck: "Today",
                                details: "Refrigeration, cooking, holding temperatures",
                                trend: "▲ 1%"
                            },
                            { 
                                title: "Staff Hygiene", 
                                status: "compliant", 
                                score: "95%",
                                icon: <FaClipboardCheck aria-hidden="true" />,
                                color: "#4CAF50",
                                lastCheck: "2 days ago",
                                details: "Hand washing, uniform, health checks",
                                trend: "▲ 2%"
                            },
                            { 
                                title: "Ingredient Quality", 
                                status: "compliant", 
                                score: "96%",
                                icon: <FaStar aria-hidden="true" />,
                                color: "#4CAF50",
                                lastCheck: "Yesterday",
                                details: "Freshness, sourcing, storage",
                                trend: "▲ 3%"
                            },
                            { 
                                title: "Food Storage", 
                                status: "pending", 
                                score: "88%",
                                icon: <FaClock aria-hidden="true" />,
                                color: "#FFC107",
                                lastCheck: "1 week ago",
                                details: "FIFO, labeling, segregation",
                                trend: "▼ 2%"
                            },
                            { 
                                title: "Preparation Standards", 
                                status: "compliant", 
                                score: "94%",
                                icon: <FaCheckCircle aria-hidden="true" />,
                                color: "#4CAF50",
                                lastCheck: "3 days ago",
                                details: "Cooking methods, cross-contamination",
                                trend: "▲ 1%"
                            },
                            { 
                                title: "Cleaning Procedures", 
                                status: "attention", 
                                score: "82%",
                                icon: <FaExclamationCircle aria-hidden="true" />,
                                color: "#f44336",
                                lastCheck: "2 weeks ago",
                                details: "Sanitization, equipment cleaning",
                                trend: "▼ 5%"
                            },
                            { 
                                title: "Allergen Management", 
                                status: "compliant", 
                                score: "97%",
                                icon: <FaShieldAlt aria-hidden="true" />,
                                color: "#4CAF50",
                                lastCheck: "Today",
                                details: "Labeling, preparation zones",
                                trend: "▲ 4%"
                            },
                            { 
                                title: "Documentation", 
                                status: "pending", 
                                score: "86%",
                                icon: <FaClock aria-hidden="true" />,
                                color: "#FFC107",
                                lastCheck: "5 days ago",
                                details: "Logs, records, certificates",
                                trend: "▼ 3%"
                            },
                            { 
                                title: "Waste Management", 
                                status: "compliant", 
                                score: "93%",
                                icon: <FaCheckCircle aria-hidden="true" />,
                                color: "#4CAF50",
                                lastCheck: "4 days ago",
                                details: "Disposal, recycling, segregation",
                                trend: "▲ 2%"
                            }
                        ].map((item, index) => (
                            <div 
                                key={index} 
                                style={{
                                    ...dashboardCardStyle,
                                    borderLeft: `5px solid ${item.color}`,
                                    padding: '20px',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    position: 'relative'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                                onClick={() => alert(`View details for ${item.title}`)}
                            >
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between', 
                                    alignItems: 'flex-start',
                                    marginBottom: '15px'
                                }}>
                                    <div style={{ flex: 1 }}>
                                        <h5 style={{ 
                                            margin: '0 0 5px 0', 
                                            color: '#333',
                                            fontSize: window.innerWidth < 768 ? '14px' : '16px',
                                            fontWeight: 'bold'
                                        }}>
                                            {item.title}
                                        </h5>
                                        <div style={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            marginBottom: '5px'
                                        }}>
                                            <span style={{ 
                                                color: item.color,
                                                fontWeight: 'bold',
                                                fontSize: window.innerWidth < 768 ? '18px' : '22px',
                                                marginRight: '10px'
                                            }}>
                                                {item.score}
                                            </span>
                                            <span style={{ 
                                                color: item.color,
                                                padding: '3px 8px',
                                                borderRadius: '12px',
                                                fontSize: '11px',
                                                fontWeight: 'bold',
                                                textTransform: 'uppercase'
                                            }}>
                                                {item.status}
                                            </span>
                                        </div>
                                        <div style={{ 
                                            fontSize: '12px',
                                            color: '#666',
                                            marginTop: '8px',
                                            lineHeight: '1.4'
                                        }}>
                                            {item.details}
                                        </div>
                                    </div>
                                    <div style={{ 
                                        fontSize: '24px', 
                                        color: item.color,
                                        marginLeft: '10px'
                                    }}>
                                        {item.icon}
                                    </div>
                                </div>
                                
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                    color: '#666',
                                    marginTop: '15px',
                                    paddingTop: '10px',
                                    borderTop: '1px solid #f0f0f0'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '5px', fontSize: '10px' }} />
                                        Checked: {item.lastCheck}
                                    </div>
                                    <div style={{
                                        color: item.trend.startsWith('▲') ? '#4CAF50' : 
                                               item.trend.startsWith('▼') ? '#f44336' : '#666',
                                        fontWeight: 'bold'
                                    }}>
                                        {item.trend}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div style={{ 
                        padding: '25px', 
                        borderRadius: '12px',
                        marginBottom: '30px',
                    }}>
                        <h4 style={{ 
                            fontSize: window.innerWidth < 768 ? '18px' : '20px',
                            color: '#1565c0',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <FaCalendarCheck aria-hidden="true" style={{ marginRight: '10px' }} />
                            Upcoming Food Safety Audits & Inspections
                        </h4>
                        
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
                            gap: '15px'
                        }}>
                            {[
                                { 
                                    title: "FSSAI Annual Inspection", 
                                    date: "2024-04-15", 
                                    status: "scheduled",
                                    type: "Regulatory",
                                    priority: "high",
                                    inspector: "Food Safety Officer",
                                    location: "Main Kitchen"
                                },
                                { 
                                    title: "Kitchen Hygiene Audit", 
                                    date: "2024-04-22", 
                                    status: "scheduled",
                                    type: "Internal",
                                    priority: "medium",
                                    inspector: "Quality Manager",
                                    location: "All Areas"
                                },
                                { 
                                    title: "Staff Training Assessment", 
                                    date: "2024-05-01", 
                                    status: "pending",
                                    type: "Training",
                                    priority: "medium",
                                    inspector: "Training Department",
                                    location: "Training Room"
                                },
                                { 
                                    title: "Supplier Quality Review", 
                                    date: "2024-05-10", 
                                    status: "planned",
                                    type: "Vendor",
                                    priority: "high",
                                    inspector: "Procurement Team",
                                    location: "Storage & Kitchen"
                                }
                            ].map((audit, index) => (
                                <div 
                                    key={index}
                                    style={{
                                        padding: '20px',
                                        borderRadius: '8px',
                                        border: '1px solid #e0e0e0'
                                    }}
                                >
                                    <div style={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        marginBottom: '10px'
                                    }}>
                                        <div>
                                            <h6 style={{ 
                                                margin: 0,
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                color: '#333'
                                            }}>
                                                {audit.title}
                                            </h6>
                                            <div style={{ 
                                                fontSize: '12px',
                                                color: '#666',
                                                marginTop: '5px'
                                            }}>
                                                Inspector: {audit.inspector} | Location: {audit.location}
                                            </div>
                                        </div>
                                        <span style={{ 
                                            color: audit.status === 'scheduled' ? '#2e7d32' : 
                                                   audit.status === 'pending' ? '#FF9800' : '#2196F3',
                                            padding: '4px 10px',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {audit.status.toUpperCase()}
                                        </span>
                                    </div>
                                    <div style={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        fontSize: '13px',
                                        color: '#666',
                                        marginTop: '15px'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '8px', fontSize: '14px' }} />
                                            <strong>Date:</strong> {audit.date}
                                        </div>
                                        <div>
                                            <span style={{ 
                                                color: audit.priority === 'high' ? '#f44336' : 
                                                       audit.priority === 'medium' ? '#FF9800' : '#4CAF50',
                                                padding: '4px 10px',
                                                borderRadius: '10px',
                                                fontSize: '11px',
                                                fontWeight: 'bold'
                                            }}>
                                                {audit.type} | {audit.priority.toUpperCase()} PRIORITY
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div style={{ 
                        padding: '25px', 
                        borderRadius: '12px',
                        marginBottom: '30px',
                    }}>
                        <h4 style={{ 
                            fontSize: window.innerWidth < 768 ? '18px' : '20px',
                            color: '#e65100',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <FaClipboardCheck aria-hidden="true" style={{ marginRight: '10px' }} />
                            Required Actions for Food Safety Compliance
                        </h4>
                        
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(2, 1fr)',
                            gap: '15px',
                            marginBottom: '20px'
                        }}>
                            <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    marginBottom: '15px'
                                }}>
                                    <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '10px', fontSize: '20px' }} />
                                    <strong style={{ color: '#f44336', fontSize: '16px' }}>
                                        Immediate Attention Required (Within 48 hours)
                                    </strong>
                                </div>
                                <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
                                    <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                        <strong>Deep Cleaning Schedule:</strong> Complete overdue deep cleaning of walk-in refrigerator
                                    </li>
                                    <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                        <strong>Temperature Logs:</strong> Submit missing temperature logs for March 15-20
                                    </li>
                                    <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                        <strong>Staff Training:</strong> 2 kitchen staff need food handler certification renewal
                                    </li>
                                    <li style={{ paddingLeft: '10px' }}>
                                        <strong>Equipment Calibration:</strong> Calibrate meat thermometer by tomorrow
                                    </li>
                                </ul>
                            </div>
                            
                            <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    marginBottom: '15px'
                                }}>
                                    <FaClock aria-hidden="true" style={{ color: '#FF9800', marginRight: '10px', fontSize: '20px' }} />
                                    <strong style={{ color: '#FF9800', fontSize: '16px' }}>
                                        Upcoming Compliance Deadlines
                                    </strong>
                                </div>
                                <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
                                    <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                        <strong>Q1 Safety Report:</strong> Due April 30, 2024
                                    </li>
                                    <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                        <strong>Pest Control Service:</strong> Scheduled for May 5, 2024
                                    </li>
                                    <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                        <strong>Fire Safety Inspection:</strong> Due May 15, 2024
                                    </li>
                                    <li style={{ paddingLeft: '10px' }}>
                                        <strong>Annual Staff Health Check:</strong> Due June 1, 2024
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div style={{ textAlign: 'center' }}>
                            <button 
                                onClick={() => alert("Generate Food Safety Report clicked")}
                                style={{
                                    ...actionButtonStyle,
                                    backgroundColor: '#4CAF50',
                                    padding: window.innerWidth < 768 ? '12px 25px' : '15px 40px',
                                    fontSize: window.innerWidth < 768 ? '14px' : '16px',
                                    fontWeight: 'bold',
                                    borderRadius: '50px',
                                    display: 'inline-flex',
                                    alignItems: 'center'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#388E3C';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#4CAF50';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                <FaChartBar aria-hidden="true" style={{ marginRight: '10px' }} />
                                Generate Food Safety Compliance Report
                            </button>
                        </div>
                    </div>

                    <div style={{ 
                        padding: '25px', 
                        borderRadius: '12px',
                        marginBottom: '30px',
                    }}>
                        <h4 style={{ 
                            fontSize: window.innerWidth < 768 ? '18px' : '20px',
                            color: '#7b1fa2',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <FaChartLine aria-hidden="true" style={{ marginRight: '10px' }} />
                            Food Safety Performance Metrics
                        </h4>
                        
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: window.innerWidth < 768 ? '1fr' : 'repeat(4, 1fr)',
                            gap: '15px'
                        }}>
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '20px', 
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }}>
                                <div style={{ fontSize: '32px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>0</div>
                                <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Critical Violations</div>
                                <div style={{ fontSize: '12px', color: '#4CAF50', fontWeight: 'bold' }}>This Month</div>
                            </div>
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '20px', 
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }}>
                                <div style={{ fontSize: '32px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>3</div>
                                <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Minor Violations</div>
                                <div style={{ fontSize: '12px', color: '#2196F3', fontWeight: 'bold' }}>Resolving</div>
                            </div>
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '20px', 
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }}>
                                <div style={{ fontSize: '32px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>12</div>
                                <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Completed Audits</div>
                                <div style={{ fontSize: '12px', color: '#FF9800', fontWeight: 'bold' }}>Last 90 Days</div>
                            </div>
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '20px', 
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }}>
                                <div style={{ fontSize: '32px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>94%</div>
                                <div style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>Compliance Score</div>
                                <div style={{ fontSize: '12px', color: '#9C27B0', fontWeight: 'bold' }}>Industry Average: 89%</div>
                            </div>
                        </div>
                    </div>

                    <div style={{ 
                        padding: '25px', 
                        borderRadius: '12px',
                        textAlign: 'center'
                    }}>
                        <h4 style={{ 
                            fontSize: window.innerWidth < 768 ? '18px' : '20px',
                            color: '#2e7d32',
                            marginBottom: '15px'
                        }}>
                            🏆 Compliance Excellence Recognition
                        </h4>
                        <p style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px', color: '#333', marginBottom: '20px' }}>
                            Your establishment maintains <strong>94% compliance score</strong>, placing you in the <strong>top 15%</strong> 
                            of Food & Beverage businesses on our platform. Keep up the excellent work!
                        </p>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '20px',
                            flexWrap: 'wrap'
                        }}>
                            <div style={{ 
                                padding: '15px', 
                                borderRadius: '8px',
                                minWidth: '150px',
                                border: '1px solid #e0e0e0'
                            }}>
                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Current Streak</div>
                                <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>180</div>
                                <div style={{ fontSize: '12px', color: '#666' }}>Days without violations</div>
                            </div>
                            <div style={{ 
                                padding: '15px', 
                                borderRadius: '8px',
                                minWidth: '150px',
                                border: '1px solid #e0e0e0'
                            }}>
                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Industry Rank</div>
                                <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>Top 15%</div>
                                <div style={{ fontSize: '12px', color: '#666' }}>Among 500+ restaurants</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    return (
        <>
            <div>
                <style>{`
                    .main-container {
                        padding: 20px;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        max-width: 100%;
                        overflow-x: hidden;
                    }

                    .tabs-wrapper {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 10px;
                        margin-left: 0px;
                        width: 100%;
                    }

                    /* Mobile view - Grid layout with full text */
                    @media (max-width: 767px) {
                        .tab-buttons {
                            display: grid !important;
                            grid-template-columns: repeat(3, 1fr) !important;
                            gap: 8px !important;
                            overflow-x: visible !important;
                            overflow-y: visible !important;
                            margin-top: ${window.innerWidth < 768 ? '40px' : '123px'} !important;
                            padding: 10px 5px !important;
                            width: 100% !important;
                            -webkit-overflow-scrolling: auto !important;
                            scrollbar-width: none !important;
                        }

                        .tab-button {
                            flex: 1 !important;
                            height: 55px !important;
                            font-size: 14px !important;
                            padding: 8px 5px !important;
                            white-space: normal !important;
                            overflow: visible !important;
                            text-overflow: unset !important;
                            min-width: 0 !important;
                            max-width: 100% !important;
                            margin: 0 !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            text-align: center !important;
                            line-height: 1.3 !important;
                            word-break: break-word !important;
                            hyphens: auto !important;
                        }
                    }

                    /* Small mobile screens */
                    @media (max-width: 400px) {
                        .tab-button {
                            font-size: 13px !important;
                            height: 40px !important;
                            padding: 6px 4px !important;
                        }
                    }

                    /* Medium mobile screens */
                    @media (min-width: 401px) and (max-width: 480px) {
                        .tab-button {
                            font-size: 13px !important;
                            height: 40px !important;
                        }
                    }

                    /* Large mobile screens */
                    @media (min-width: 481px) and (max-width: 767px) {
                        .tab-button {
                            font-size: 15px !important;
                            height: 50px !important;
                        }
                    }

                    /* Tablet view - Horizontal layout */
                    @media (min-width: 768px) and (max-width: 991px) {
                        .tab-buttons {
                            display: flex !important;
                            flex-wrap: nowrap !important;
                            overflow-x: auto !important;
                            overflow-y: hidden !important;
                            margin-top: ${window.innerWidth < 768 ? '60px' : '123px'} !important;
                            padding: 10px 5px !important;
                            width: 100% !important;
                            -webkit-overflow-scrolling: touch !important;
                            scrollbar-width: none !important;
                            gap: 5px !important;
                        }

                        .tab-button {
                            flex: 0 0 auto !important;
                            height: 42px !important;
                            font-size: 13px !important;
                            padding: 0 15px !important;
                            white-space: nowrap !important;
                            overflow: visible !important;
                            margin: 0 !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            min-width: max-content !important;
                        }
                    }

                    /* Desktop view - Evenly distributed */
                    @media (min-width: 992px) {
                        .tab-buttons {
                            display: flex !important;
                            justify-content: space-between !important;
                            overflow-x: visible !important;
                            gap: 5px !important;
                            margin-top: ${window.innerWidth < 768 ? '60px' : '123px'} !important;
                            padding: 10px 5px !important;
                            width: 100% !important;
                        }
                        
                        .tab-button {
                            flex: 1 !important;
                            min-width: 0 !important;
                            padding: 0 5px !important;
                            height: 45px !important;
                            font-size: 14px !important;
                            // white-space: nowrap !important;
                            // overflow: hidden !important;
                            // text-overflow: ellipsis !important;
                        }
                    }
                        @media(min-width:1000px){
                        .tab-button{
                        font-size: 16px !important;
                        }
                        }

                    .tab-buttons::-webkit-scrollbar {
                        display: none;
                    }

                    .tab-button {
                        border: none;
                        border-radius: 8px;
                        background-color: #d9d9d9;
                        color: #000;
                        font-weight: 500;
                        cursor: pointer;
                        transition: background-color 0.3s ease;
                    }

                    .tab-button.active {
                        background-color: #b15cd6;
                        color: white;
                    }

                    .tab-content {
                        margin-top: 0px;
                        width: 100%;
                        overflow-x: hidden;
                        overflow-y: auto;
                    }

                    .tab-content::-webkit-scrollbar {
                        width: 4px;
                        height: 4px;
                    }

                    .tab-content::-webkit-scrollbar-track {
                        background: #f0f0f0;
                    }

                    .tab-content::-webkit-scrollbar-thumb {
                        background: #b15cd6;
                        border-radius: 10px;
                    }

                    .sidebar {
                        margin-top: 30px;
                        max-height: 600px;
                        overflow-y: auto;
                    }

                    .card {
                        width: 100%;
                        max-width: 300px;
                        height: 120px;
                        background: #ccc;
                        border-radius: 8px;
                        margin: 10px auto;
                        position: relative;
                        padding: 10px;
                    }

                    @media (max-width: 576px) {
                        .container-fluid {
                            padding-left: 5px;
                            padding-right: 5px;
                        }

                        .col-lg-7, .col-lg-3 {
                            padding-left: 5px;
                            padding-right: 5px;
                        }
                    }

                    @media (min-width: 576px) and (max-width: 768px) {
                        .tab-button {
                            height: 45px;
                        }
                    }

                    @media (min-width: 768px) and (max-width: 992px) {
                        .tab-button {
                            font-size: 13px;
                            padding: 0 8px;
                        }
                    }

                    @media (min-width: 992px) {
                        .left-column {
                            width: 100%;
                            padding-right: 95px;
                            max-height: 700px;
                        }

                        .right-column {
                            width: 30%;
                            position: sticky;
                            top: -30px;
                            max-height: 700px;
                            overflow-y: auto;
                        }
                    }

                    @media (max-width : 991px) {
                        .hideits {
                            display: none !important;
                        }
                    }

                    .sidebar::-webkit-scrollbar,
                    .left-column::-webkit-scrollbar {
                        width: 0px;
                        background: transparent;
                    }

                    @media (max-width: 768px) {
                        .company-mobile-data {
                            height: auto !important;
                            min-height: calc(100vh - 120px);
                        }

                        .profile-mobilescroll {
                            margin-top: 0 !important;
                        }
                    }
                        @media(max-width:425px){
                        .tab-buttons{
                        grid-template-columns: repeat(2, 1fr) !important;
                        }
                        }
                `}</style>

                <div className="container-fluid company-mobile-data" style={{ 
                    height: "auto", 
                    minHeight: "500px",
                    paddingLeft: window.innerWidth < 768 ? '5px' : '15px',
                    paddingRight: window.innerWidth < 768 ? '5px' : '15px'
                }}>
                    <div className="row" style={{ margin: 0 }}>
                        <div className="col-lg-2 col-md-1"></div>
                        <div className="col-lg-7 col-md-8 col-sm-12" style={{ 
                            paddingLeft: window.innerWidth < 768 ? '5px' : '15px',
                            paddingRight: window.innerWidth < 768 ? '5px' : '15px',
                            width:window.innerWidth<769 ? "95vw" : " ",
                        }}>
                            <p
                                className="breadcrumb maamaas-home-bredcum"
                                style={{
                                    position: "fixed",
                                top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px" ,                            
                                    left: 0,
                                    width: "100%",
                                    //backgroundColor: "#fff",
                                    zIndex: 1000,
                                    padding: "10px 15px",
                                    fontSize: window.innerWidth < 576 ? "14px" : window.innerWidth < 768 ? "15px" : "18px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    margin: 0,
                                    //borderBottom: "1px solid #e0e0e0",
                                    //boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
                                }}
                            >
                                <Link
                                    to="/foodladingpage"
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                        fontSize: window.innerWidth < 576 ? "14px" : "inherit"
                                    }}
                                >
                                    Food & Beverages
                                </Link>
                                <span className="separator" style={{ margin: "0 8px", color: "#666" }}> &gt; </span>
                                <span style={{ color: "purple", fontSize: window.innerWidth < 576 ? "14px" : "inherit" }}>
                                    Legal & Compliance
                                </span>
                                <span className="separator" style={{ margin: "0 8px", color: "#666" }}> &gt; </span>
                                <span style={{ 
                                    color: "purple", 
                                    fontWeight: "bold",
                                    fontSize: window.innerWidth < 576 ? "14px" : "inherit"
                                }}>
                                    {activeTab}
                                </span>
                            </p>

                            <div className="profile-mobilescroll" style={{ 
                                marginTop: window.innerWidth < 768 ? "80px" : "100px",
                                width: "100%"
                            }}>
                                <div style={{ width: "100%" }}>
                                    <div className="tab-buttons">
                                        {["Privacy Policy", "Terms & Conditions", "Vendor Guidelines", "Compliance Status"].map((label) => (
                                            <button
                                                key={label}
                                                className={`tab-button ${activeTab === label ? "active" : ""}`}
                                                onClick={() => {
                                                    setActiveTab(label);
                                                    
                                                    // Set flag when Terms tab is opened for auto-agree
                                                    if (label === "Terms & Conditions") {
                                                        setTermsTabJustOpened(true);
                                                    } else {
                                                        setTermsTabJustOpened(false);
                                                    }
                                                    
                                                    // Scroll tab content to top
                                                    const tabContent = document.querySelector('.tab-content');
                                                    if (tabContent) {
                                                        tabContent.scrollTop = 0;
                                                    }
                                                    // Also scroll page to top for better UX
                                                    window.scrollTo({
                                                        top: 0,
                                                        behavior: 'smooth'
                                                    });
                                                    // Scroll tab buttons to make active tab visible (for tablet/desktop)
                                                    if (window.innerWidth >= 768) {
                                                        const tabButtons = document.querySelector('.tab-buttons');
                                                        const activeButton = document.querySelector('.tab-button.active');
                                                        if (tabButtons && activeButton) {
                                                            const leftPos = activeButton.offsetLeft - tabButtons.offsetLeft;
                                                            tabButtons.scrollTo({
                                                                left: leftPos - 20,
                                                                behavior: 'smooth'
                                                            });
                                                        }
                                                    }
                                                }}
                                            >
                                                {label}
                                            </button>
                                        ))}
                                    </div>
                                    <div
                                        className="tab-content"
                                        style={{
                                            // height: containerHeight,
                                            // overflowX: "hidden",
                                            // overflowY: "auto",
                                            padding: window.innerWidth < 768 ? "5px" : "0",
                                            marginTop: "0px"
                                        }}
                                    >
                                        {tabContent[activeTab]}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 hideits" style={{ 
                            paddingLeft: window.innerWidth < 992 ? '5px' : '15px',
                            paddingRight: window.innerWidth < 992 ? '5px' : '15px'
                        }}>
                            <Foodandbeveragesadvertise />
                        </div>
                    </div>
                </div>
            </div>

            <DocumentViewerModal 
                isOpen={showDocumentViewer}
                onClose={handleCloseDocumentViewer}
                title={currentDocument.title}
                content={currentDocument.content}
            />
        </>
    );
};

// Styles
const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: window.innerWidth < 768 ? "15px" : "20px",
    marginBottom: "20px",
    width: "100%",
    border: "1px solid #e0e0e0",
    height:window.innerHeight<600 ? "60vh" :"65vh",
     overflow:"auto"
    
};

const dashboardCardStyle = {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "15px",
    minHeight: "100px",
    border: "1px solid #e0e0e0"
};

const actionButtonStyle = {
    backgroundColor: "#2196F3",
    color: "white",
    border: "none",
    padding: "8px 15px",
    borderRadius: "5px",
    cursor: "pointer",
    display: 'inline-flex',
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    transition: "all 0.3s ease"
};

export default FoodLeagelandcompliance;